{
  "createHub": {
    "title": "Create",
    "open": "Create",
    "close": "Close",
    "actionsHeader": "Start",
    "newWorkout": {
      "title": "New workout",
      "sub": "Start a blank workout now"
    },
    "repeatWorkout": {
      "title": "Repeat workout",
      "sub": "Log again from a past workout"
    },
    "planProgram": {
      "title": "Plan a program",
      "sub": "Build a multi-week training program"
    },
    "planWorkout": {
      "title": "Plan a workout",
      "sub": "Prepare a single session for later"
    }
  },
  "library": {
    "header": "Browse",
    "tabPrograms": "Programs",
    "tabWorkouts": "Workouts",
    "tabPersonal": "Mine",
    "tabCoach": "Coach",
    "tabFavorites": "Favorites",
    "favoriteA11y": "Favorite",
    "errFavorite": "Could not update favorites.",
    "emptyFavoritesTitle": "No favorites yet",
    "emptyFavoritesSub": "Star a program or workout to keep it up here.",
    "sectionOfficial": "By JackedLogs",
    "sectionPersonal": "Mine",
    "clone": "Clone",
    "copySuffix": "(copy)",
    "following": "Following…",
    "searchPlaceholder": "Search by name…",
    "filters": "Filters",
    "clearFilters": "Clear",
    "axisLevel": "Level",
    "axisPerWeek": "Sessions / week",
    "noResultsTitle": "No matches",
    "noResultsSub": "Adjust the search or the filters.",
    "loading": "Loading the library…",
    "errLoad": "Could not load the library.",
    "errClone": "Could not clone. Try again.",
    "errDelete": "Could not delete. Try again.",
    "errFollow": "Could not follow the program.",
    "errStatus": "Could not update the program.",
    "emptyTitle": "Nothing here yet",
    "emptySub": "Programs and workouts you create or clone will show up here.",
    "coachSoonTitle": "From your coach",
    "coachSoonSub": "Programs and workouts your coach assigns will show up here."
  },
  "common": {
    "lastDataAt": "Last data {{at}}",
    "languageA11y": "Language",
    "infoA11y": "Info",
    "unsavedChanges": {
      "title": "Discard changes?",
      "body": "You'll lose your unsaved edits.",
      "keepEditing": "Keep editing",
      "discard": "Discard"
    }
  },
  "bodymap": {
    "viewBack": "Back",
    "viewFront": "Front",
    "workedTitle": "Worked muscles",
    "workedPrimary": "primary",
    "workedSecondary": "secondary",
    "heatmapTitle": "Most-trained muscles",
    "heatmapLow": "low",
    "heatmapHigh": "high",
    "window7d": "7 days",
    "window30d": "30 days",
    "painTitle": "Pain map",
    "painHelp": "Tap a muscle to mark it: red (avoid heavy load), yellow (caution). Saved automatically.",
    "painRed": "avoid",
    "painYellow": "caution",
    "painClearAll": "Clear all",
    "painSaving": "Saving…",
    "painSaveError": "Save failed. Check your connection.",
    "painRiskA11y": "Pain risk: {{severity}}",
    "painSeverity": {
      "red": "high",
      "yellow": "medium",
      "green": "low"
    }
  },
  "plates": {
    "title": "Plate breakdown",
    "openHint": "Show plate breakdown",
    "close": "Close",
    "targetLabel": "Target",
    "barLabel": "Bar",
    "barAria": "Barbell weight",
    "barNone": "No bar",
    "perSide": "Per side",
    "perSidePair": "{{count}} × {{plate}}",
    "barOnly": "Just the bar — no plates needed.",
    "belowBar": "Target is lighter than the bar.",
    "invalidInput": "Enter a valid weight first.",
    "remainder": "+{{weight}} short of target with the current inventory.",
    "fallbackPill": "closest possible",
    "inventoryLegend": "Pairs available",
    "inventoryHint": "Pairs of each plate available right now. Set to 0 if the gym doesn't have it or the rack is empty. Saved across sessions.",
    "pairsAria": "Pairs of {{plate}} available",
    "loadedEnd": "Loaded end",
    "landmineHint": "Landmine: only the free end is loaded. The other end is anchored to the floor pivot."
  },
  "app": {
    "title": "JackedLogs",
    "tagline": "Strength training, logged plain.",
    "signedInAs": "Signed in as <bold>{{email}}</bold>.",
    "signOut": "Sign out",
    "loading": "Loading…",
    "checking": "checking…"
  },
  "auth": {
    "signIn": "Sign in",
    "signInFailed": "Sign-in failed. Check your email and password.",
    "createAccount": "Create account",
    "email": "Email",
    "emailPlaceholder": "email@example.com",
    "password": "Password",
    "passwordHint": "At least 10 characters with upper, lower, and a number.",
    "switchToSignUp": "Need an account? Create one.",
    "switchToSignIn": "Already have an account? Sign in.",
    "submitting": "Working…",
    "confirmTitle": "Confirm your email",
    "confirmHelp": "We sent a code to <bold>{{email}}</bold>. Paste it below to finish creating the account.",
    "confirmCode": "Confirmation code",
    "confirmSubmit": "Confirm",
    "confirming": "Confirming…",
    "resendCode": "Resend code",
    "resentInfo": "Code resent. Check your inbox.",
    "confirmedNowSignIn": "Account confirmed. Sign in to continue.",
    "forgotLink": "Forgot your password?",
    "forgotTitle": "Reset your password",
    "forgotIntro": "Enter your email and we will send you a code to reset the password.",
    "forgotSendCode": "Send code",
    "forgotCodeSent": "Code sent. Check your inbox.",
    "forgotConfirmHelp": "We sent a code to <bold>{{email}}</bold>. Type it below with the new password.",
    "forgotResetSubmit": "Reset password",
    "forgotResetDone": "Password updated. Sign in with the new one.",
    "newPassword": "New password",
    "backToSignIn": "Back to sign in"
  },
  "dashboard": {
    "meTitle": "Authenticated round-trip — /api/me",
    "healthTitle": "API health",
    "exportData": "Export my data",
    "deleteAccount": "Delete my account",
    "exporting": "Preparing export…",
    "deleting": "Deleting…",
    "deleteConfirm": "This will permanently delete your account and all your data. Type DELETE to confirm.",
    "deleteCancel": "Cancel",
    "deletePlaceholder": "DELETE",
    "deleteSuccess": "Account deleted.",
    "exportFilename": "jackedlogs-export-{{date}}.json",
    "privacyTitle": "Privacy",
    "privacyHelp": "Export everything as JSON or wipe the account end to end. Deletes are permanent."
  },
  "privacy": {
    "linkLabel": "Privacy",
    "title": "Privacy notice",
    "lastUpdated": "Last updated: 20 August 2026 (legal basis)",
    "intro": "JackedLogs is built and operated by a single individual. This notice explains what we collect, where it lives, and what you can do about it.",
    "section1Title": "What we collect",
    "section1Body": "Only what is strictly necessary to operate the service: your email address (used as the account identifier), a hashed password (managed by Amazon Cognito — the plaintext never leaves your browser), and the workout data you choose to enter. We do not collect names, addresses, phone numbers, dates of birth, or any analytics fingerprint. Bodyweight is opt-in: you can enter it on your profile so the app can compute the effective load on bodyweight exercises (e.g. dips, chin-ups). It is treated as special-category health data under GDPR Art. 9 and Swiss nLPD Art. 5 lett. c — never aggregated, never logged, wiped along with the rest of your data on account delete.",
    "section2Title": "Where it lives",
    "section2Body": "All data is stored in AWS region eu-central-2 (Zurich, Switzerland). Authentication runs on Amazon Cognito; structured data on Amazon DynamoDB; static assets on Amazon CloudFront. We use no third-party analytics, advertising, or tracking services.",
    "section3Title": "Your rights",
    "section3Body": "At any time you can export your full data set (JSON) or permanently delete your account from the dashboard. Deletion removes your authentication record and every record we hold keyed to your account, with no soft-delete fallback.",
    "section4Title": "Contact",
    "section4Body": "Questions or requests: {{email}}.",
    "section5Title": "Legal basis",
    "section5Body": "The legal basis for processing, under Swiss nLPD and EU GDPR, is your consent at sign-up plus the legitimate interest of providing the requested service. We will update this notice before any expansion of scope.",
    "back": "Back"
  },
  "errors": {
    "generic": "Something went wrong."
  },
  "feedback": {
    "title": "Send feedback",
    "help": "Found a bug, want a feature, or have something else to share? Send a note here. Submissions land in the admin inbox.",
    "kindLabel": "Type",
    "kind_bug": "Bug",
    "kind_feature": "Feature request",
    "kind_other": "Other",
    "bodyLabel": "What happened?",
    "bodyPlaceholder": "Describe what you saw, what you expected, and how to reproduce.",
    "send": "Send",
    "sending": "Sending…",
    "sentFlash": "Thanks — sent.",
    "sentHint": "We'll triage it next session. You can close this now.",
    "close": "Close",
    "errEmpty": "Write something before sending.",
    "errSubmit": "Couldn't send. Try again in a moment.",
    "errRateLimit": "Too many submissions in the last hour. Try again later.",
    "inboxTitle": "Feedback inbox",
    "loading": "Loading feedback…",
    "empty": "No feedback to show.",
    "filterAll": "All",
    "loadMore": "Load more",
    "status_open": "Open",
    "status_in_progress": "In progress",
    "status_shipped": "Shipped",
    "status_wontfix": "Won't fix",
    "priorityLabel": "Priority",
    "priorityNone": "None",
    "statusLabel": "Status",
    "head_open": "{{count}} open",
    "head_in_progress": "{{count}} in progress",
    "head_shipped": "{{count}} shipped",
    "head_wontfix": "{{count}} won't fix",
    "headTotal": "{{count}} total"
  },
  "profile": {
    "title": "Profile",
    "loading": "Loading profile…",
    "name": "Display name",
    "namePlaceholder": "How should we call you?",
    "role": "Role",
    "roleCoach": "Coach",
    "roleAthlete": "Athlete",
    "roleBoth": "Both",
    "ageBucket": "Age range (optional)",
    "ageBucketHelp": "Used only for opt-in anonymous group statistics. Stays empty if you skip it.",
    "ageBucketNone": "Prefer not to say",
    "unitsPreference": "Preferred unit",
    "unitsPreferenceHelp": "We always store weights in kilograms. Each workout entry can override the unit on input.",
    "preferredFigure": "Body figure on the bodymap",
    "preferredFigureHelp": "Pick the figure the muscle map renders as. Decoupled from sex — no one is asking. Web shows male only until the library swap; mobile honours both.",
    "figure_masculine": "Masculine",
    "figure_feminine": "Feminine",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Profile saved.",
    "agePrefix_under_18": "Under 18",
    "age_18-24": "18-24",
    "age_25-29": "25-29",
    "age_30-34": "30-34",
    "age_35-39": "35-39",
    "age_40-44": "40-44",
    "age_45-49": "45-49",
    "age_50-54": "50-54",
    "age_55-59": "55-59",
    "age_60-64": "60-64",
    "age_65-69": "65-69",
    "age_70-plus": "70+",
    "bodyweight": "Bodyweight (optional)",
    "bodyweightPlaceholder": "e.g. 78",
    "bodyweightHelp": "Used only to compute the effective load on bodyweight exercises. Never aggregated, never logged, wiped on account delete.",
    "errBodyweight": "Enter a bodyweight between 20 and 300 kg (or the equivalent in lb).",
    "apk": {
      "title": "Android APK (test build)",
      "hint": "Family-only test build. Install on Android by enabling \"Install from unknown apps\" in your browser, then opening the file.",
      "download": "Download APK"
    },
    "email": "Email",
    "metaTitle": "Session"
  },
  "workout": {
    "title": "Workouts",
    "loading": "Loading workouts…",
    "empty": "No workouts logged yet.",
    "logNew": "Log workout",
    "startedAt": "When",
    "exercise": "Exercise",
    "exercisePlaceholder": "Pick an exercise",
    "errPickExercise": "Pick an exercise from the catalog.",
    "catalogEmptyCoach": "The catalog is empty. Add at least one exercise before logging a workout.",
    "catalogEmptyAthlete": "The catalog is empty. One of your coaches has to add exercises before you can log a workout.",
    "setsLegend": "Sets",
    "set": "Set",
    "reps": "Reps",
    "amrapHint": "AMRAP — push past the prescribed floor",
    "weight": "Weight",
    "extra": "Extra (+/−)",
    "unit": "Unit",
    "rpe": "RPE",
    "addSet": "Add set",
    "removeSet": "Remove set",
    "notes": "Notes (optional)",
    "setNoteToggle": "Add a note to this set",
    "setNotePlaceholder": "What was different about this set",
    "draftRecoveryHeadline": "You have an unfinished workout from {{when}}.",
    "draftRecoveryContinue": "Continue",
    "draftRecoveryDiscard": "Discard",
    "maxBumpAvailable": "{{exercise}}: new MAX at {{value}}",
    "maxBumpConfirm": "↑ Confirm",
    "maxBumpSaving": "Saving…",
    "prefillFromDate": "Prefill from {{date}}?",
    "prefillAccept": "Use it",
    "prefillDismiss": "Skip",
    "savePromptTitle": "Check before saving",
    "savePromptContinue": "Back to workout",
    "savePromptAnyway": "Save anyway",
    "unmarkedPromptBody": "{{count}} sets have data but no completion mark.",
    "unmarkedPromptFail": "Mark as failed and save",
    "unmarkedPromptComplete": "Mark as done and save",
    "outlierPromptBody": "{{count}} entries look unusual:",
    "outlierItem": "{{exercise}}: {{weight}} (history max {{expected}})",
    "outlierE1rmItem": "{{exercise}}: implied 1RM {{e1rm}} (history max {{expected}})",
    "outlierPerImplementItem": "{{exercise}}: {{weight}} is ~double your usual {{expected}} — did you enter the weight of ONE implement, or the total of both?",
    "outlierRepsItem": "{{exercise}}: {{reps}} reps — looks too high",
    "outlierZeroWeightItem": "{{exercise}}: {{reps}} reps with no weight",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Workout saved.",
    "savedEdit": "Workout updated.",
    "savedEditOldRemains": "Workout updated, but the previous version is still in your history. Delete it manually.",
    "deleted": "Workout deleted.",
    "cancel": "Cancel",
    "errNoSets": "Add at least one valid set.",
    "creatingTitle": "New workout",
    "editingTitle": "Edit workout",
    "exerciseN": "Exercise {{n}}",
    "addExercise": "Add another exercise",
    "removeExercise": "Remove exercise",
    "removeExerciseConfirm": "Remove {{name}} from this workout? Any logged sets on it will be lost.",
    "groupAlignTitle": "Different set counts",
    "groupAlignBody": "Members of this group have between {{shortest}} and {{longest}} sets. Align them so the rounds line up?",
    "groupAlignPad": "+ Pad to {{n}}",
    "groupAlignTrim": "− Trim to {{n}}",
    "groupAlignTrimWarning": "Trimming deletes sets that are already logged, and cannot be undone.",
    "groupAlignTrimHint": "Deletes the extra sets from every member of the group. Cannot be undone.",
    "groupAlignKeep": "Keep as is",
    "splitGroup": "Split",
    "splitGroupTitle": "Split this group?",
    "splitGroupBody": "Members keep their sets and stay in the workout, just unlinked. You can re-group them anytime.",
    "splitGroupConfirm": "Split",
    "removeRoundConfirmTitle": "Remove this round?",
    "removeRoundConfirmBody": "Round {{n}} of {{names}} will be dropped together.",
    "bilateral": "Bilateral",
    "unilateral": "Unilateral",
    "edit": "Edit",
    "repeat": "Repeat",
    "delete": "Delete",
    "deleting": "Deleting…",
    "deleteConfirm": "Delete this workout?",
    "distance": "m",
    "duration": "s",
    "cardioDuration": "Duration",
    "cardioDistance": "Distance",
    "cardioWeight": "Weight",
    "cardioHr": "Avg HR",
    "cardioCalories": "Calories",
    "cardioOptionalsShow": "Other fields",
    "cardioOptionalsHide": "Other fields",
    "dateEditor": "Date & duration",
    "dateLabel": "Date",
    "startTimeLabel": "Start",
    "endTimeLabel": "End",
    "durationLabel": "Duration",
    "side": "Side",
    "sideLeft": "Left",
    "sideRight": "Right",
    "sideBoth": "Both",
    "showRpe": "Track RPE",
    "showDuration": "Track duration",
    "rir": "RIR {{n}}",
    "swap": "Swap",
    "swapHint": "Bench taken? Pick a similar exercise.",
    "descriptionToggle": "Show / hide description",
    "failShort": "F",
    "failToggle": "Mark set as failed",
    "failHint": "Last rep missed. Counts in volume, excluded from PR.",
    "startRest": "Start rest timer",
    "restStartDefault": "Start rest ({{n}}s)",
    "restStartCustom": "Start rest ({{n}}s, exercise default)",
    "setComplete": "Mark set complete",
    "setCompleteHint": "Stamp this set as done and start a {{n}}s rest.",
    "setCompleteHintCustom": "Stamp this set as done and start a {{n}}s rest (exercise default).",
    "setUndo": "Undo set completion",
    "setUndoHint": "Tap again to undo and reset the rest timer.",
    "restLeft": "Rest",
    "restDone": "Time's up",
    "restStop": "Stop",
    "restPause": "Pause",
    "restResume": "Resume",
    "restSound": "Beep at end of rest",
    "instructions": "Coach instructions (optional)",
    "instructionsPlaceholder": "Focus for the session, what to skip if time-pressed, intent.",
    "lastTime": "Last",
    "lastToday": "today",
    "lastDaysAgo": "{{n}}d ago",
    "dropsetShort": "Drop",
    "dropsetToggle": "Add a dropset chain",
    "dropsetHint": "Chain extra reps after this set with no rest.",
    "dropsetTitle": "Dropset",
    "dropsetVariant": "Variant",
    "dropsetClassical": "Classical (drop weight)",
    "dropsetMyorep": "Myo-rep (same load)",
    "dropsetHintClassical": "Lower the load 10–30% and chase reps to fatigue. No rest.",
    "dropsetHintMyorep": "Same load, fewer reps, 10–20s breath, repeat.",
    "dropsetSameLoad": "= top",
    "dropsetAddStep": "Add drop",
    "dropsetRemove": "Remove",
    "dropsetRemoveConfirm": "You have {{n}} drop steps. Convert back to a working set and discard them?",
    "dropsetRemoveStep": "Remove drop",
    "groupLabel": "Group",
    "groupNone": "(none)",
    "groupCreate": "Create new",
    "groupNewSuperset": "New superset",
    "groupNewCircuit": "New circuit",
    "groupJoinExisting": "Join an existing group",
    "groupLeave": "Ungroup",
    "groupSharedHint": "Shared. Open another exercise and pick the same group from this dropdown to pair them.",
    "supersetN": "Superset {{n}}",
    "circuitN": "Circuit {{n}}",
    "supersetDerived": "Superset (auto)",
    "supersetDerivedTitle": "Detected from alternating sets in this session",
    "playActiveTitle": "Active exercise — most recent completed set",
    "errGroupKindMixed": "A single group can't mix superset and circuit. Pick one kind.",
    "exerciseNew": "New exercise",
    "cardMenu": "Exercise options",
    "menuReplace": "Replace exercise",
    "menuGroup": "Group / superset",
    "menuMoveUp": "Move up",
    "menuMoveDown": "Move down",
    "menuShowNotes": "Show notes",
    "menuHideNotes": "Hide notes",
    "menuShowDescription": "Show description",
    "menuHideDescription": "Hide description",
    "tipAlternatives": "Alternative exercises",
    "tipCoachNote": "Coach note",
    "perImplementHint": "Using two, or one side at a time? Log the weight of just one. The app counts both (×2).",
    "tipProgramNote": "In this program",
    "tipNoAlternatives": "No similar exercises in the catalog",
    "tipClose": "Close",
    "painBanner": {
      "red": "Stresses a painful muscle",
      "yellow": "Caution: loads a flagged muscle",
      "green": "No pain risk"
    },
    "setCycleHint": "Tap: done · again: failed · again: undo",
    "setStatePending": "Set pending",
    "setStateDone": "Set completed",
    "setStatePr": "Set completed, personal record",
    "setStateFailed": "Set marked failed",
    "prShort": "🏆",
    "addDrop": "+ drop",
    "groupBannerSuperset": "SUPERSET",
    "groupBannerCircuit": "CIRCUIT",
    "groupAutoTag": "AUTO",
    "groupAutoConfirm": "Lock",
    "groupAutoConfirmAria": "Lock the group: stop the detector and keep these exercises tied together",
    "groupAutoDismiss": "Dismiss",
    "groupAutoDismissAria": "Ignore the detection: split these back into solo exercises",
    "groupAddSetAll": "Add a set to every member",
    "nameLabel": "Name (optional)",
    "namePlaceholder": "e.g. Push A · Lower Quad-Dominant",
    "durationStepperA11y": "duration stepper",
    "rirLabel": "RIR",
    "showRir": "Track RIR",
    "maxDownA11y": "MAX may have dropped",
    "animationOf": "Animation of {{name}}",
    "animationZoomHint": "Opens the animation full screen",
    "closeAnimation": "Close the animation",
    "showAnimation": "Show the animation",
    "showBodyMap": "Show the muscles worked",
    "pageOf": "{{current}} of {{total}}",
    "pagerDot": "{{target}}, {{current}} of {{total}}"
  },
  "program": {
    "title": "Programs",
    "help": "Multi-week training cycles. Phase 5.1 ships the shell — name, weeks, sessions per week. The slot and progression builder lands next.",
    "new": "New program",
    "newTitle": "New program",
    "name": "Name",
    "namePlaceholder": "e.g. Powerbuilding 6-week",
    "cycleWeeks": "Cycle weeks",
    "sessionsPerWeek": "Sessions per week",
    "description": "Description",
    "descriptionPlaceholder": "What this cycle is for, who it's aimed at, any notes for the athletes.",
    "create": "Create",
    "creating": "New program: {{name}}",
    "cancel": "Cancel",
    "delete": "Delete",
    "deleteConfirm": "Confirm?",
    "deleteConfirmYes": "Yes, delete",
    "loading": "Loading programs…",
    "empty": "No programs yet. Create one to plan a multi-week cycle.",
    "statusDraft": "Draft",
    "statusActive": "Active",
    "statusArchived": "Archived",
    "cycleWeeksLabel": "{{n}}-week cycle",
    "sessionsPerWeekLabel": "{{n}}× / week",
    "slotCount": "{{n}} slot(s)",
    "skeletonHint": "Skeleton only. Slots get filled in the next phase.",
    "sessionDefaultName": "Session {{n}}",
    "edit": "Edit",
    "editing": "Editing: {{name}}",
    "backToList": "Back to programs",
    "save": "Save",
    "saving": "Saving…",
    "errSave": "Could not save the program.",
    "metaLegend": "Program",
    "status": "Status",
    "metaCyclesLive": "Structural edits (days, weeks) apply as you make them",
    "ordinalSession": "{{n}}ª session",
    "sessionName": "Session name",
    "slotN": "Slot {{n}}",
    "addSlot": "Add slot",
    "removeSlot": "Remove",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "exercise": "Exercise",
    "exercisePick": "Pick an exercise",
    "setsLegend": "Sets",
    "addSet": "Add set",
    "removeSet": "Remove set",
    "reps": "Reps",
    "setNotesPlaceholder": "Per-set note (optional)",
    "set": "Set",
    "intensityKind": "Intensity",
    "intensityNone": "None (athlete picks)",
    "intensityPercent": "% of MAX",
    "intensityAbs": "kg (absolute)",
    "intensityRpe": "RPE",
    "intensity_percent-of-max": "Percentage",
    "intensity_absolute": "Weight (kg)",
    "intensity_rpe": "RPE",
    "weekShort": "W{{n}}",
    "previewShow": "Preview",
    "previewHide": "Hide preview",
    "previewMuscles": "Muscles touched",
    "previewSets": "{{n}} sets",
    "previewEmptySession": "No slots in this session.",
    "previewEmptyProgram": "No slots yet. Open Edit to add some.",
    "start": "Start session",
    "startCancel": "Cancel",
    "startGo": "Start",
    "starting": "Starting…",
    "startWeek": "Week",
    "startSession": "Session",
    "progressNext": "Next: W{{w}} · Session {{s}}",
    "instructions": "Instructions",
    "instructionsPlaceholder": "Tempo, pause length, technique focus, RPE target.",
    "amrapLastSet": "AMRAP on last set",
    "maxAttempt": "1MAX attempt",
    "amrapBadge": "AMRAP",
    "maxBadge": "1MAX",
    "slotCycleHint": "Applied across {{n}} weeks of the cycle.",
    "catalogLoading": "Loading the exercise catalog…",
    "builderComingSoon": "The slot and progression builder lands in Phase 5.2. For now, this creates an empty shell you can delete or fill later.",
    "errCycleWeeks": "Cycle weeks must be between 1 and 12.",
    "errSessionsPerWeek": "Sessions per week must be between 1 and 7.",
    "errName": "Program name is required.",
    "errEmptyDay": "Every training day needs at least one exercise.",
    "errSchema": "Invalid program data.",
    "errCreate": "Could not create program.",
    "errCode": {
      "sessionNameEmpty": "Every training day needs a name.",
      "slotNoExercise": "Pick an exercise for every slot.",
      "slotNoSets": "Every exercise needs at least one set.",
      "slotAllWeeksInactive": "An exercise is off on every week. Switch on a week or remove it.",
      "rowWidthMismatch": "A set row doesn't match the number of weeks. Reopen the exercise and try again.",
      "invalidReps": "Check the reps: use a number like 8, or 8+ for AMRAP.",
      "groupKindMixed": "A superset mixes set types. Give its exercises the same type.",
      "schemaInvalid": "Invalid program data.",
      "noSession": "There's no workout to save.",
      "planNameEmpty": "Plan name is required.",
      "planNoExercises": "Add at least one exercise to the plan.",
      "invalidIntensityValue": "Check the intensity value: it should be a number.",
      "weightOutOfRange": "That weight is out of range.",
      "pctOutOfRange": "The percentage must be between 0 and 200.",
      "rpeOutOfRange": "RPE must be between 1 and 10.",
      "rirOutOfRange": "RIR must be between 0 and 10.",
      "unknownIntensityKind": "Unknown intensity type.",
      "invalidSeconds": "Check the seconds: a timed set needs a length, in whole seconds up to 3600."
    },
    "cardMenu": "Slot menu",
    "menuGroup": "Group",
    "groupNone": "No group",
    "groupJoinExisting": "Join existing",
    "groupCreate": "Create",
    "groupNewSuperset": "New superset",
    "groupNewCircuit": "New circuit",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Circuit {{letter}}",
    "assignTo": "Assign to athletes",
    "assignToHelp": "The program is added to each athlete's library. They need an active coach edge with you first.",
    "assignSelf": "You (creator)",
    "addAssignee": "Add",
    "removeAssignee": "Remove",
    "assigneePlaceholder": "athlete@example.com",
    "follow": "Follow",
    "unfollow": "Unfollow",
    "followHint": "Follow this program (it shows up in In progress)",
    "publish": "Publish",
    "unpublish": "Back to draft",
    "publishAndFollow": "Publish and follow",
    "publishHint": "Make this program available to follow",
    "chipDraft": "Draft",
    "chipPublished": "Published",
    "chipFollowed": "Following",
    "kindShortAbsolute": "KG",
    "kindShortAbsoluteLb": "LB",
    "kindShortPercent": "%MAX",
    "kindShortHistory": "HIST",
    "kindShortRpe": "RPE",
    "kindShortRir": "RIR",
    "languageUndeclared": "Language",
    "languageA11y": "Writing language",
    "languageSwitchQuestion": "Which language are you writing in?",
    "languageDeclareQuestion": "Which language is this program written in?",
    "languageFootnote": "Translations are optional. A program in one language is complete.",
    "languageDeclareFootnote": "Nothing gets translated: this only records the language.",
    "languageAuto": "Machine translation",
    "languageNotYetWritten": "No {{lang}} version yet. The {{original}} text stays where it is.",
    "setBound": "Bound by",
    "boundReps": "Reps",
    "boundTime": "Time",
    "boundOpen": "Open",
    "workSeconds": "Work (s)",
    "restSeconds": "Rest (s)",
    "restSecondsPlaceholder": "auto",
    "prescribeTime": "Time",
    "prescribeTimeA11y": "Prescribe work and rest in seconds",
    "seconds": "Seconds",
    "amrapNotWithTime": "A {{secs}}s bout can't also be an AMRAP: a plan can't ask how many you'll manage. Drop the + or the time.",
    "workSecondsRequired": "How long?"
  },
  "me": {
    "targets": {
      "title": "Goals",
      "historyByCoach": "Your coach",
      "errNotFound": "Couldn't find your targets. Go back and retry."
    }
  },
  "coach": {
    "title": "Coach & athletes",
    "subtitle": "Athletes you coach and coaches who coach you. Invitations need both sides to consent before assignments can flow.",
    "subLabel": "sub",
    "inviteAthleteLabel": "Invite an athlete by email",
    "invitePlaceholder": "athlete@example.com",
    "inviteNotePlaceholder": "Note (optional)",
    "inviteSend": "Send invite",
    "inviteSending": "Sending…",
    "inviteSent": "Invite sent. The athlete sees it on their next sign-in.",
    "athletesHeading": "Athletes I coach",
    "coachesHeading": "Coaches who coach me",
    "athletesEmpty": "No athletes yet. Invite one above.",
    "pendingInLabel": "Awaiting your response",
    "pendingOutLabel": "Waiting on them",
    "activeLabel": "Active",
    "accept": "Accept",
    "decline": "Decline",
    "cancel": "Cancel invite",
    "revoke": "Revoke",
    "leave": "Leave coach",
    "busy": "Working…",
    "loading": "Loading edges…",
    "loadFailed": "Could not load. Refresh to retry.",
    "errCode": {
      "invalid_email": "That email looks malformed.",
      "email_not_found": "No verified account with that email.",
      "peer_required": "Provide an email or a sub.",
      "edge_exists": "An edge with this peer already exists.",
      "userpool_not_configured": "Server misconfigured: user pool unavailable.",
      "io_error": "Network or server error. Try again.",
      "not_pending": "This invitation isn't pending any more.",
      "wrong_party": "Only the other side can accept this invite."
    },
    "dashboard": {
      "title": "Team overview",
      "unnamedAthlete": "Athlete",
      "empty": "No athletes yet",
      "emptySub": "Invite athletes from Coach & athletes to see them here.",
      "loading": "Loading your team…",
      "loadFailed": "Could not load your team. Refresh to retry.",
      "noProgram": "No program",
      "kpiAssigned": "Athletes",
      "kpiActive": "Active this week",
      "kpiAttention": "Need attention",
      "kpiAdherence": "Avg adherence",
      "kpiSessions": "Sessions this week",
      "adherence": "adherence",
      "lastToday": "today",
      "lastNever": "never trained",
      "lastDaysAgo": "{{count}}d ago",
      "flagStale": "Not training",
      "flagUnderTarget": "Under target",
      "flagOnTrack": "On track",
      "flagNoProgram": "No program"
    },
    "detail": {
      "back": "Back to team",
      "maxesTitle": "Current MAX",
      "maxesEmpty": "No MAX recorded yet",
      "rhythmSummary": "avg {{avg}}/week over {{weeks}} weeks · last week: {{last}}",
      "effortTitle": "Effort coverage",
      "effortLabel": "sets with a recorded RIR",
      "effortSummary": "{{tagged}} of {{counted}} counted sets, warm-ups included",
      "effortEra": "Effort data starts {{date}} · {{count}} earlier sets aren't counted",
      "effortNone": "No set carries an effort value yet, so the hard-set and target numbers have nothing to rest on.",
      "effortError": "Couldn't load the effort data.",
      "maxesSeeAll": "Show all (+{{count}})",
      "maxesShowFewer": "Show fewer"
    },
    "targets": {
      "eyebrow": "Weekly targets",
      "edit": "Edit targets",
      "degradedHint": "This athlete has no weekly targets yet. Set some to score their week against a goal.",
      "noGrant": "Read-only — the athlete hasn't granted you target edits.",
      "historyTitle": "Change history",
      "historyEmpty": "No changes yet.",
      "historyByYou": "You",
      "historyTruncated": "Showing the most recent 1000 changes.",
      "histGeneric": "Targets updated",
      "histSet": "set to {{value}}",
      "histRemoved": "removed",
      "histChanged": "{{from}} → {{to}}",
      "histLine": "{{label}} · {{metric}}: {{body}}",
      "historyLoading": "Loading…",
      "errLoad": "Couldn't load these targets. Go back and retry.",
      "errStale": "These targets changed while you were editing. Reload and re-apply.",
      "errNoGrant": "The athlete hasn't granted you target edits.",
      "errNotCoach": "You aren't this athlete's coach.",
      "errMultiAssignee": "This program is shared by more than one athlete.",
      "errRetry": "Still loading — try again in a moment.",
      "errNotFound": "This program no longer exists.",
      "errOffline": "Couldn't save. Check your connection and try again."
    }
  },
  "plans": {
    "title": "Plans",
    "help": "Draft a workout for yourself. Targets can be absolute kg or a percentage of your MAX, resolved to kg when you start the plan.",
    "loading": "Loading plans…",
    "empty": "No plans yet. Add one to draft a session in advance.",
    "todayPill": "Today",
    "add": "Add a plan",
    "edit": "Edit",
    "start": "Start",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Plan saved.",
    "savedEdit": "Plan updated.",
    "deleted": "Plan deleted.",
    "delete": "Delete",
    "deleting": "Deleting…",
    "deleteConfirm": "Delete this plan?",
    "creatingTitle": "New plan",
    "editingTitle": "Edit plan",
    "name": "Name",
    "namePlaceholder": "e.g. Squat day",
    "scheduledFor": "Scheduled for (optional)",
    "pickDate": "Pick a date",
    "pickDateHint": "Opens the date picker",
    "clearDate": "Clear date",
    "noDate": "Not set",
    "notes": "Notes (optional)",
    "rpeEnabledLabel": "Show RPE column in the Logger",
    "rpeEnabledHelp": "When on, sessions started from this plan open with the RPE column visible. Athletes can still toggle it per session.",
    "exercise": "Exercise",
    "exercisePlaceholder": "Pick an exercise",
    "exerciseN": "Exercise {{n}}",
    "removeExercise": "Remove exercise",
    "addExercise": "Add another exercise",
    "setsLegend": "Sets",
    "targetReps": "Reps",
    "targetWeight": "Weight",
    "targetKind": "Unit",
    "targetRpe": "RPE",
    "noMaxYet": "no MAX set",
    "addSet": "Add set",
    "removeSet": "Remove set",
    "statusDraft": "Draft",
    "statusScheduled": "Scheduled",
    "statusCompleted": "Completed",
    "statusSkipped": "Skipped",
    "errNotSignedIn": "You must be signed in.",
    "errNameRequired": "Give the plan a name.",
    "errPickExercise": "Pick an exercise from the catalog.",
    "errNoSets": "Add at least one valid set.",
    "errGroupKindMixed": "Two entries share a group id but disagree on whether it's a superset or a circuit. Pick one and re-save.",
    "assignTo": "Also assign to",
    "assignToHelp": "Type an email and press Enter. The address must already have an account or the plan is rejected.",
    "addAssignee": "Add",
    "removeAssignee": "Remove",
    "assigneePlaceholder": "name@example.com",
    "exerciseNew": "Pick an exercise",
    "setIndex": "Set {{n}}",
    "cardMenu": "Card menu",
    "menuGroup": "Group",
    "menuMoveUp": "Move up",
    "menuMoveDown": "Move down",
    "groupNone": "No group",
    "groupJoinExisting": "Join existing",
    "groupCreate": "Create",
    "groupNewSuperset": "New superset",
    "groupNewCircuit": "New circuit",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Circuit {{letter}}",
    "details": "Details",
    "exercisesLabel": "Exercises",
    "editorEmpty": "No exercises yet. Add one to start building this plan.",
    "selectExercisePrompt": "Select an exercise to edit its sets.",
    "addExerciseCta": "Add exercise",
    "removeExerciseConfirm": "Remove this exercise?",
    "removeExerciseHint": "Tap once to confirm, then tap again to remove.",
    "collapseExercise": "Collapse exercise",
    "supersetTag": "SUPERSET",
    "exerciseNoteLabel": "Exercise note (optional)"
  },
  "templates": {
    "show": "Browse starter templates",
    "hide": "Hide templates",
    "help": "Common starter plans and programs. Clone one into your account — you can edit or delete the copy without touching the template.",
    "loading": "Loading templates…",
    "empty": "No templates available right now.",
    "errLoad": "Could not load templates.",
    "clone": "Clone to my plans",
    "cloning": "Cloning…",
    "cloned": "Cloned \"{{name}}\".",
    "alreadyCloned": "Already cloned",
    "difficultyBeginner": "Beginner",
    "difficultyIntermediate": "Intermediate",
    "difficultyAdvanced": "Advanced",
    "planMeta": "{{n}} exercise(s)",
    "programMeta": "{{weeks}}-week cycle · {{sessions}}× / week"
  },
  "maxes": {
    "title": "Maxes",
    "countLabel_one": "{{count}} set",
    "countLabel_other": "{{count}} set",
    "help": "MAX is what you can hit today, set by you. Programs use it as the percentage base. The estimated 1RM in the Progress section is for reference only.",
    "loading": "Loading maxes…",
    "empty": "No maxes set yet. Add one to drive percentage-based programming.",
    "add": "Add a max",
    "edit": "Edit",
    "delete": "Delete",
    "deleteAction": "Delete max",
    "deleting": "Deleting…",
    "deleted": "Max deleted.",
    "deleteConfirm": "Delete the MAX for {{name}}? The history is removed too. The next seed-from-history pass can repopulate it from your workouts.",
    "exercise": "Exercise",
    "exercisePlaceholder": "Pick an exercise",
    "value": "Value",
    "source": "Source",
    "sourceManual": "Set manually",
    "sourceTested": "Tested in the gym",
    "sourceDerived": "Derived from a logged set",
    "sourceCalculated": "Seeded from history",
    "sourceImported": "Imported",
    "notes": "Notes (optional)",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Max saved.",
    "cancel": "Cancel",
    "errPickExercise": "Pick an exercise.",
    "errInvalidValue": "Enter a value between 0 and 2000.",
    "seed": {
      "start": "Suggest from history",
      "loading": "Reading your workout history…",
      "reviewIntro": "{{count}} exercises have a credible top set in your history. Pick the ones to seed as MAX. Exercises that already have a MAX are skipped.",
      "selectAll": "Select all",
      "selectNone": "Select none",
      "fromSet": "from {{weight}} × {{reps}}",
      "cancel": "Cancel",
      "apply": "Seed {{count}} maxes",
      "applying": "Saving: {{done}} / {{total}}",
      "applied": "Seeded {{count}} maxes from history.",
      "noneApplicable": "Nothing to seed. Either every exercise already has a MAX, or no weighted history was found.",
      "close": "Close"
    }
  },
  "progress": {
    "coverageTitle": "Muscle coverage",
    "coverageSubtitle": "vs weekly target",
    "coverageTopTrained": "Your most-trained muscles this week.",
    "coverageLead": "Under your weekly target: {{count}}",
    "coverageAllGood": "Every targeted muscle is on track this week.",
    "coverageAvg": "avg {{n}}/wk",
    "coverageSeeAll": "See all muscles (+{{count}})",
    "coverageShowFewer": "Show fewer",
    "detailsTitle": "More detail",
    "detailsSubtitle": "Deeper training analytics",
    "period": {
      "days": "{{days}} d",
      "painDays": "7 / {{days}} d",
      "selectorLabel": "Analysis window"
    },
    "title": "Progress",
    "show": "Show",
    "hide": "Hide",
    "help": "MAX is the value you set yourself; estimated 1RM uses Epley as a reference. Volume is the sum of weight times reps for the session.",
    "e1rm": "Estimated 1RM",
    "max": "MAX",
    "maxLabel": "MAX",
    "estimatedBadge": "estimated 1RM in dashed",
    "volume": "Volume",
    "sessions": "{{n}} sessions",
    "prFound": "Personal record at {{weight}}.",
    "prUpdate": "Update MAX to {{weight}}",
    "prUpdating": "Updating…",
    "viewByExercise": "By exercise",
    "viewByTag": "By tag",
    "noTags": "No tagged sessions yet. Tag exercises in the catalog to see aggregate volume here.",
    "totalVolume": "Total {{weight}}",
    "recordsScope": "Records",
    "recordsAllTime": "All time",
    "recordsThisYear": "{{year}}",
    "filterPlaceholder": "Filter exercises",
    "filterCount": "{{visible}} of {{total}}",
    "filterNoMatch": "No exercise matches the filter.",
    "coverageNoData": "Nothing to score yet — log a session, or set a weekly target."
  },
  "cohort": {
    "compare": "Compare to cohort (anonymous)",
    "hide": "Hide cohort",
    "loading": "Loading cohort…",
    "empty": "Not enough contributors yet to show a comparison. The minimum is ten people in the same age group.",
    "contributors": "Based on {{n}} anonymous contributors with their age range set.",
    "yourGroup": "your group"
  },
  "catalog": {
    "title": "Exercise catalog",
    "loading": "Loading…",
    "empty": "No exercises yet.",
    "seedStarter": "Seed a starter set",
    "seeding": "Seeding…",
    "importTaxonomy": "Import full exercise library",
    "importTaxonomyUpsert": "Refresh from exercise library",
    "importing": "Importing…",
    "importDone": "Library import done. Created {{created}}, refreshed {{upserted}}, skipped {{skipped}}, failed {{failed}}.",
    "add": "Add an exercise",
    "edit": "Edit",
    "cancel": "Cancel",
    "save": "Save",
    "create": "Create",
    "saving": "Saving…",
    "name": "Name",
    "namePlaceholder": "e.g. Back Squat",
    "primaryMuscle": "Primary muscle (optional)",
    "primaryMusclePlaceholder": "e.g. quads",
    "primaryLabel": "Primary muscles (at least one)",
    "secondaryLabel": "Secondary muscles (optional)",
    "addMuscle": "+ Add muscle",
    "removeMuscle": "Remove muscle",
    "errPrimaryRequired": "Pick at least one primary muscle.",
    "isBodyweight": "Bodyweight exercise",
    "isBodyweightHelp": "Sets log reps and an optional extra-load weight instead of a barbell load.",
    "hasP1RM": "Can be programmed by percentage of MAX",
    "hasP1RMHelp": "Lets plans target a fraction of your MAX for this lift.",
    "defaultRest": "Default rest (s)",
    "defaultRestPlaceholder": "e.g. 180",
    "defaultRestHelp": "Seconds the rest timer counts down by default. Leave blank to use the app default (90s).",
    "defaultBar": "Specialty bar weight (kg)",
    "defaultBarPlaceholder": "e.g. 7",
    "defaultBarHelp": "Curl bar 7, trap bar 11, landmine ~10. The plate calculator opens with this value pre-selected on sets of this exercise. Leave blank to use the dropdown default.",
    "pinnedNoteLabel": "Setup cue (optional)",
    "pinnedNotePlaceholder": "e.g. Rack height 4, safety pins 6, pause 1s",
    "pinnedNoteHelp": "Shown as a banner under the exercise title in the Logger. Plan-level and program-slot notes override this when present.",
    "noMuscle": "-",
    "bw": "BW",
    "p1rm": "1RM%",
    "errSlug": "Use Latin letters in the name so the system can build a stable identifier.",
    "errSlugExists": "An exercise with this name already exists.",
    "searchPlaceholder": "Search exercises…",
    "region": "Region",
    "regionAll": "All regions",
    "region_lower": "Lower body",
    "region_posterior": "Posterior chain",
    "region_chest": "Chest",
    "region_back": "Back",
    "region_shoulders": "Shoulders",
    "region_arms": "Arms",
    "region_core": "Core",
    "region_cardio": "Cardio",
    "region_other": "Other",
    "pattern": "Pattern",
    "patternAll": "All patterns",
    "pattern_squat": "Squat",
    "pattern_hinge": "Hinge",
    "pattern_horizontal-push": "Horizontal push",
    "pattern_vertical-push": "Vertical push",
    "pattern_horizontal-pull": "Horizontal pull",
    "pattern_vertical-pull": "Vertical pull",
    "pattern_lunge": "Lunge",
    "pattern_carry": "Carry",
    "pattern_core": "Core",
    "pattern_isolation": "Isolation",
    "pattern_cardio": "Cardio",
    "pattern_other": "Other",
    "equipment": "Equipment",
    "equipmentAll": "All equipment",
    "equipment_barbell": "Barbell",
    "equipment_dumbbell": "Dumbbell",
    "equipment_kettlebell": "Kettlebell",
    "equipment_cable": "Cable",
    "equipment_machine": "Machine",
    "equipment_bodyweight": "Bodyweight",
    "equipment_band": "Band",
    "equipment_other": "Other",
    "clearFilters": "Clear filters",
    "noResults": "No exercises match these filters.",
    "tags": "Tags",
    "tagsHelp": "Free-form labels for filtering and reports. Type a slug and press Enter, or click Suggest to seed from the structured fields.",
    "tagsPlaceholder": "e.g. compound, warmup, for-sandrine",
    "addTag": "Add",
    "removeTag": "Remove tag",
    "suggestTags": "Suggest",
    "description": "Description",
    "descriptionHelp": "Short note shown in the catalog and as a hint in the workout logger. Other languages are filled automatically.",
    "descriptionPlaceholder": "Setup, key cue, common mistake…",
    "descriptionResetDefault": "Reset to bundled default",
    "locale_en": "EN",
    "locale_it": "IT",
    "locale_fr": "FR",
    "locale_de": "DE",
    "locale_ru": "RU",
    "equipment_treadmill": "Treadmill",
    "equipment_exercise-bike": "Exercise bike",
    "equipment_elliptical": "Elliptical",
    "equipment_rower": "Rower",
    "equipment_stair-climber": "Stair climber",
    "equipment_jump-rope": "Jump rope",
    "equipment_battle-ropes": "Battle ropes",
    "equipment_sled": "Sled",
    "deletedExercise": "Deleted exercise"
  },
  "swap": {
    "title": "Swap exercise",
    "currentLabel": "Current",
    "searchPlaceholder": "Search the catalog…",
    "showAll": "Show all exercises",
    "noMatches": "No exercises match your search.",
    "noSuggestions": "No tagged similars found. Tick \"Show all\" to browse the full catalog.",
    "close": "Close",
    "reasonTags": "Tag overlap ×{{count}}",
    "reasonPrimary": "Muscle overlap ×{{count}}",
    "reasonDifferentEquipment": "Different gear",
    "suggestedSection": "Suggested",
    "allSection": "All exercises",
    "whichMachine": "Which machine?",
    "defaultMachine": "Default machine",
    "machineLabel": "Machine {{letter}}",
    "setMachine": "Set machine",
    "machineChoices": "Machines known: {{count}}",
    "newMachine": "New machine",
    "bandSession": "Session",
    "bandCurrentExercise": "This exercise",
    "bandOtherExercises": "Switch to another exercise",
    "equipmentKey": "Gear",
    "currentConsequence": "Sets you already logged stay: only the gear they are marked on changes.",
    "unavailableTitle": "Not here?",
    "unavailableBody": "Tick the {{exercise}} gear that is not at {{place}}. Only what you tick is recorded.",
    "unavailableConfirm": "Save",
    "unavailableOpen": "Gear not available here",
    "unavailableOpenHint": "Asks which of this exercise's gear is missing.",
    "unavailableBadge": "Not here",
    "unavailableRestore": "Available here again",
    "unavailableErrorTitle": "Not saved",
    "unavailableErrorBody": "That gear is still marked as available here.",
    "unavailableConfirmHint": "Tick at least one to save.",
    "pinDefaultMachine": "Always use the default machine here",
    "pinMachine": "Always use {{machine}} here",
    "pinHint": "Stops asking which machine, at this gym, for this exercise.",
    "pinErrorTitle": "Not saved",
    "pinErrorBody": "The default machine here is unchanged.",
    "unpinDefaultMachine": "Stop always using the default machine here",
    "unpinMachine": "Stop always using {{machine}} here",
    "pinnedFootnoteDefault": "Always uses the default machine here.",
    "pinnedFootnoteMachine": "Always uses {{machine}} here.",
    "unpinHint": "Goes back to asking which machine, at this gym, for this exercise."
  },
  "mobile": {
    "bodymap": {
      "muscle": {
        "chest": "Chest",
        "biceps": "Biceps",
        "triceps": "Triceps",
        "forearm": "Forearms",
        "front-deltoids": "Shoulders",
        "back-deltoids": "Rear delts",
        "trapezius": "Traps",
        "upper-back": "Back",
        "lower-back": "Lower back",
        "abs": "Core",
        "obliques": "Core",
        "quadriceps": "Quads",
        "hamstring": "Hamstrings",
        "gluteal": "Glutes",
        "adductors": "Adductors",
        "abductors": "Abductors",
        "calves": "Calves",
        "tibialis": "Tibialis",
        "neck": "Neck",
        "head": "Head"
      }
    },
    "tabs": {
      "workouts": "Workouts",
      "plan": "Home",
      "progress": "Progress",
      "catalog": "Catalog",
      "profile": "Profile",
      "settings": "Settings",
      "inbox": "Inbox",
      "athletes": "Athletes",
      "me": "Me"
    },
    "me": {
      "sectionTraining": "Training",
      "navTargets": "Goals",
      "navTargetsSub": "Your weekly training targets"
    },
    "settings": {
      "title": "Settings",
      "exercisesSection": "Exercises",
      "navExercisesSub": "MAXes, catalog, effort scale",
      "navCatalog": "Exercise catalog",
      "selectPrompt": "Select a setting to open it.",
      "navCatalogSub": "Browse the exercise library",
      "navEffort": "Effort settings",
      "navEffortSub": "RIR / RPE scale + legend",
      "navLicenses": "Open source licenses",
      "navLicensesSub": "Libraries that power the app",
      "sectionAccount": "Account",
      "sectionTraining": "Training",
      "sectionBody": "Body",
      "sectionPrefs": "Preferences",
      "sectionCoach": "Coach",
      "sectionAbout": "About",
      "sectionHealthConnect": "Health Connect",
      "navHealthConnect": "Health Connect",
      "navHealthConnectSub": "Sync workouts & health data from your device"
    },
    "energySource": {
      "zepp": "Zepp",
      "googleFit": "Google Fit",
      "healthConnect": "Health Connect",
      "jlEstimate": "JackedLogs",
      "pillLabel": "Calorie sources",
      "projectionNote": "Includes the set you're about to do: a projection of the whole session, not work you've already logged.",
      "selected": "selected"
    },
    "hc": {
      "preferences": "Preferences",
      "caloriesWins": "Health Connect wins for calories",
      "caloriesWinsHelp": "When both exist, show the calories measured through Health Connect instead of JackedLogs' own estimate. Off = prefer the estimate. With no Health Connect value, the estimate is always used.",
      "title": "Health Connect",
      "intro": "Import your watch & phone activity into JackedLogs. Walks, hikes and rides become workouts; heart rate and calories enrich the sessions you log. Off until you connect.",
      "checking": "Checking…",
      "unavailable": "Health Connect is not available on this device.",
      "updateRequired": "Update the Health Connect app to continue.",
      "notConnected": "Not connected.",
      "connect": "Connect Health Connect",
      "connectHelp": "You choose which data JackedLogs may read. Change it any time in Health Connect.",
      "connected": "Connected",
      "reads": "Reading workouts, heart rate and calories.",
      "syncNow": "Sync now",
      "neverSynced": "Not synced yet.",
      "lastSyncedAt": "Last sync: {{when}}",
      "syncDelayNote": "New activity can take a few minutes to reach Health Connect from your device — a recent walk or ride may only appear on a later sync. That delay is normal.",
      "syncFullHistory": "Sync full history",
      "syncingFullHistory": "Syncing full history",
      "syncFullHistoryHelp": "Re-check your whole history and fill any gaps in Health Connect. Use this if a past correction is missing there. Safe to repeat.",
      "resultSummary": "{{imported}} imported · {{enriched}} enriched · {{skipped}} skipped",
      "error": "Something went wrong. Please try again.",
      "manageInHc": "Manage in Health Connect",
      "disconnect": "Disconnect",
      "disconnectTitle": "Disconnect Health Connect?",
      "disconnectBody": "JackedLogs will stop reading your Health Connect data. Workouts already imported stay in your history.",
      "logoA11y": "Health Connect",
      "privacyTitle": "Your data",
      "privacyBody": "JackedLogs reads only what you allow in Health Connect, and only on this phone after you connect. It is stored in your private JackedLogs account, never shared or sold. Disconnect any time to stop.",
      "bodyResult": "{{imported}} body imported · {{skipped}} skipped",
      "bodyNotGranted": "Body data not granted yet. Tap Grant body data.",
      "readsFull": "Reading workouts, heart rate and calories, weight and body composition, glucose and nutrition. Writing glucose back to Health Connect.",
      "backfillTitle": "Import history from May?",
      "backfillBody": "Scans your Health Connect history back to May and imports anything missing. Safe to run more than once: already-imported items are skipped.",
      "backfillNow": "Import history",
      "grantExtra": "Grant health data",
      "extraGrantBody": "Also import weight, body composition, glucose and nutrition.",
      "metabolicResult": "{{glucose}} glucose · {{nutrition}} nutrition imported",
      "metabolicNotGranted": "Glucose and nutrition not granted yet.",
      "writeGlucoseGrantBody": "Allow JackedLogs to write glucose to Health Connect.",
      "grantWrite": "Allow write",
      "syncGlucoseToHc": "Write glucose to Health Connect"
    },
    "metabolic": {
      "title": "Metabolic",
      "loading": "Loading…",
      "empty": "Connect Health Connect and sync to see glucose and nutrition here.",
      "glucoseEmpty": "No glucose readings",
      "glucoseLatest": "Latest glucose",
      "mgdl": "mg/dL",
      "targetBand": "Typical target range {{lo}}–{{hi}} {{unit}}.",
      "carbsToday": "Carbs today",
      "grams": "g",
      "glucoseTitle": "Glucose",
      "glucoseCurrent": "Latest: {{value}} {{unit}}",
      "glucoseNone": "Log a reading to track your glucose."
    },
    "exercisesScreen": {
      "back": "Back"
    },
    "body": {
      "back": "Back",
      "title": "Body",
      "navTitle": "Body",
      "navSub": "Sex, age, figure, pain map",
      "trendsWebHint": "Body-composition charts are on the mobile app.",
      "sexLabel": "Sex",
      "sexHelp": "Used only for the body-fat estimate. The body-map figure is a separate choice below.",
      "sex_male": "Male",
      "sex_female": "Female",
      "measurementsTitle": "Measurements",
      "measurementsSub": "Weight, circumferences, body-fat estimate",
      "measureTitle": "NEW MEASUREMENT",
      "weight": "Weight",
      "field_heightCm": "Height",
      "field_neckCm": "Neck",
      "field_chestCm": "Chest",
      "field_waistCm": "Waist",
      "field_hipsCm": "Hips",
      "field_bicepsLCm": "Biceps (L)",
      "field_bicepsRCm": "Biceps (R)",
      "field_forearmsLCm": "Forearm (L)",
      "field_forearmsRCm": "Forearm (R)",
      "field_thighsLCm": "Thigh (L)",
      "field_thighsRCm": "Thigh (R)",
      "field_calvesLCm": "Calf (L)",
      "field_calvesRCm": "Calf (R)",
      "measureSave": "Save entered values",
      "measureHelpC": "Fill only what you measured. Empty fields aren't saved.",
      "useLastA11y": "Use last value {{value}}",
      "saveFailedTitle": "Couldn't save",
      "saveFailedBody": "Your measurement wasn't saved. Your values are kept — tap Save to retry.",
      "editTitle": "EDIT — {{date}}",
      "saveChanges": "Save changes",
      "editCancelA11y": "Cancel edit",
      "editRowA11y": "Edit measurement {{date}}",
      "editHelp": "Change a value, or clear it to remove it from history.",
      "trendsLabel": "TRENDS",
      "trendsHint": "select metrics",
      "trendsExpandA11y": "Show all metrics",
      "trendsCollapseA11y": "Collapse metrics",
      "trendsEmpty": "Log at least 2 measurements to see a trend.",
      "metricComposition": "Composition",
      "metricBodyFat": "Body fat",
      "metricLeanMass": "Lean mass",
      "loadError": "Couldn't load measurements — check your connection.",
      "queuedNote": "Waiting to sync: {{count}}",
      "navyTitle": "BODY COMPOSITION (NAVY)",
      "navyNeedsEntry": "Save a measurement below to estimate body fat.",
      "navyNeedsSex": "Set your sex above to estimate body fat.",
      "navyNeedsInputs": "Add height, neck, waist (and hips, for the female formula) to estimate body fat.",
      "navyBodyFat": "Body fat ≈ {{pct}}%",
      "navyLeanMass": "Lean mass ≈ {{mass}}",
      "navyDisclaimer": "US Navy estimate (~±3.5%). Watch the trend, not the single number.",
      "historyEmpty": "No measurements yet. Save one above to start tracking.",
      "historyTitle": "HISTORY",
      "trendWeight": "WEIGHT TREND",
      "trendBodyFat": "BODY-FAT TREND",
      "deleteTitle": "Delete measurement?",
      "deleteEmptyTitle": "Remove this measurement?",
      "deleteEmptyBody": "All its values are cleared, so the entry will be deleted.",
      "deleteCancel": "Cancel",
      "deleteConfirm": "Delete",
      "ageLabel": "Age",
      "ageHelp": "Optional. Tap again to clear.",
      "dualCurveLegend": "Solid: estimate · Dashed: Health Connect",
      "bodyFatProvenance": "Body fat is calculated from waist and neck.",
      "bodyFatProvenanceWithHips": "Body fat is calculated from waist, neck and hips."
    },
    "effortSettings": {
      "back": "Back",
      "title": "Effort",
      "scaleLabel": "Effort scale",
      "scaleHelp": "Which scale the Logger speaks. RIR = reps left in the tank; RPE = perceived exertion. RPE = 10 − RIR, so they are the same effort on two scales."
    },
    "plan": {
      "currentBlockError": "Couldn't set the current block. Please try again.",
      "currentBlockOn": "Current block — tap to unpin",
      "currentBlockOff": "Set as current block",
      "currentBlockHint": "Pins this program's weekly targets to the Home meter",
      "title": "Plan",
      "start": "Start",
      "starting": "Starting…",
      "programWeekSession": "Week {{week}}/{{cycle}} · {{session}}",
      "programLastCompleted": "Last: W{{week}} · {{session}}",
      "programNextHeader": "Next up",
      "programStartCta": "▶ Start {{session}}",
      "programChangeLink": "Change week or session ›",
      "carouselPosition": "Program {{n}} of {{total}}",
      "carouselPrev": "Previous program",
      "carouselNext": "Next program",
      "programWeekLabel": "Week",
      "singleCycle": "Single cycle, same every week",
      "programSessionLabel": "Session",
      "programWeekShort": "W{{n}}",
      "programDayShort": "D{{n}}",
      "sessionN": "Session {{n}}",
      "sessionNShort": "S{{n}}",
      "programConfirm": "Start W{{week}} · {{session}}",
      "cancel": "Cancel",
      "newWorkout": "New workout",
      "programsHint": "Multi-week cycles that auto-advance as you log sessions.",
      "planDeleteTitle": "Delete plan?",
      "programDeleteTitle": "Delete program?",
      "programStatusError": "Could not update the program. Try again.",
      "view": "View",
      "hide": "Hide",
      "programUnfollowHint": "Stop following this program (it stays in My programs)",
      "programNextInline": "Next: W{{week}} · {{session}}",
      "programStartA11y": "Start {{session}}",
      "startPlanA11y": "Start {{name}}"
    },
    "preview": {
      "muscles": "Muscles",
      "noSets": "No sets prescribed",
      "alternates": "Alternates: {{names}}",
      "gridTitle": "Intensity · day × week",
      "gridHint": "Tap a day to see its lifts.",
      "matrixTitle": "Intensity · by set",
      "matrixHint": "Tap an exercise to see its sets.",
      "restDay": "Rest / light",
      "intensity": {
        "work": "work",
        "moderate": "moderate",
        "heavy": "heavy",
        "max": "Max",
        "free": "free"
      }
    },
    "catalog": {
      "title": "Catalog",
      "search": "Search exercises",
      "empty": "No exercises match.",
      "back": "Back",
      "notFound": "Exercise not found.",
      "metaPrimaryMuscle": "Primary muscle",
      "metaPattern": "Pattern",
      "metaEquipment": "Equipment",
      "metaP1RM": "Programmable",
      "metaP1RMYes": "Yes",
      "metaP1RMNo": "No",
      "metaDefaultBar": "Default bar",
      "metaBarLoading": "Bar loading",
      "metaBarLoadingLandmine": "Landmine (single end)",
      "aliasesLabel": "Also known as",
      "tagsLabel": "Tags",
      "historyLabel": "Recent sessions",
      "historyEmpty": "No past sessions for this exercise.",
      "historyError": "Could not load history.",
      "historyBodyweight": "{{reps}} reps BW",
      "recordsLabel": "Records",
      "recordsEmpty": "No records yet.",
      "selectPrompt": "Select an exercise to see its details.",
      "recordsError": "Could not load records.",
      "refreshing": "Updating…"
    },
    "maxes": {
      "title": "MAXes",
      "back": "Back",
      "search": "Search exercises",
      "empty": "No exercises match.",
      "editCancel": "Cancel",
      "editSave": "Save",
      "errInvalid": "Enter a valid weight.",
      "clearAction": "Remove MAX",
      "clearTitle": "Remove this MAX?",
      "clearBody": "The current value and history are kept on the server but the MAX will read as unset.",
      "clearCancel": "Cancel",
      "clearConfirm": "Remove",
      "selectPrompt": "Select an exercise to set its MAX.",
      "unitChipLabel": "Weight unit: {{unit}}",
      "unitKg": "kilograms",
      "unitLb": "pounds",
      "unitChipHint": "Switches the unit and converts the value"
    },
    "login": {
      "title": "JackedLogs",
      "subtitle": "Sign in to your account",
      "submit": "Sign in"
    },
    "workouts": {
      "title": "Workouts",
      "empty": "No workouts logged yet.",
      "fallbackName": "Workout",
      "endOfList_one": "{{count}} session — end of list.",
      "endOfList_other": "{{count}} sessions — end of list.",
      "newButton": "New",
      "queuedBanner_one": "{{count}} workout queued — tap to retry.",
      "queuedBanner_other": "{{count}} workouts queued — tap to retry.",
      "maxQueuedBanner_one": "{{count}} MAX waiting to sync. It sends itself when you're back online.",
      "maxQueuedBanner_other": "{{count}} MAXes waiting to sync. They send themselves when you're back online.",
      "maxQueuedHint": "Tap to sync it now.",
      "maxConfirmFailedTitle": "MAX not saved",
      "maxConfirmFailedBody": "The server would not accept this value, so nothing was written. Your MAX is unchanged. You can set it by hand from Me, Maxes.",
      "queuedRetry": "Retry",
      "queuedDetail": "Details",
      "queuedHint": "Tap to retry now, or long-press to discard.",
      "queuedHintDetail": "Tap to see what's queued, or long-press to discard.",
      "queueDismissTitle": "Discard queued workouts?",
      "queueDismissBody_one": "{{count}} workout will be removed and not saved.",
      "queueDismissBody_other": "{{count}} workouts will be removed and not saved.",
      "queueDismissCancel": "Cancel",
      "queueDismissConfirm": "Discard",
      "editUnsupportedTitle": "Edit not yet supported on mobile",
      "editUnsupportedBody": "This workout contains exercise types (P1RM, loaded carry) the mobile logger can't edit yet. Open it on the web app instead.",
      "editUnsupportedAck": "OK",
      "maxBumpHeader_one": "{{count}} new MAX",
      "maxBumpHeader_other": "{{count}} new MAXes",
      "maxBumpRow": "{{exercise}}: {{valueKg}} kg",
      "maxBumpConfirm": "Confirm",
      "maxBumpDismiss": "Skip",
      "repeat": "Repeat workout",
      "resumePillAction": "Resume",
      "resumePillFallback": "Workout in progress",
      "cancel": "Cancel",
      "loadOlder": "Load older months",
      "selectPrompt": "Select a workout to see its summary.",
      "loadError": "Could not load this session.",
      "maxDropRow": "{{exercise}}: MAX may have dropped to {{valueKg}} kg (was {{currentKg}}, {{weeks}} wks ago)",
      "maxDropConfirm": "Lower to {{valueKg}}",
      "maxDropKeep": "Keep {{valueKg}}",
      "maxDropBadDay": "Bad day",
      "importedBadge": "Imported"
    },
    "outboxDetail": {
      "title": "Queued workouts",
      "close": "Close",
      "empty": "Nothing queued.",
      "statusQueued": "Queued",
      "statusSending": "Sending",
      "statusFailed4xx": "Server rejected",
      "statusPermanentFail": "Gave up",
      "attempts_one": "{{count}} attempt",
      "attempts_other": "{{count}} attempts",
      "dismissOne": "Dismiss",
      "dismissOneTitle": "Dismiss this workout?",
      "dismissOneBody": "The workout from {{date}} will be removed without saving.",
      "dismissCancel": "Cancel",
      "dismissConfirm": "Dismiss",
      "retryAll": "Retry all",
      "dismissAll": "Dismiss all",
      "queueWorkout": "Workout",
      "queueWorkoutNote": "Workout note",
      "queueMeasurement": "Measurement",
      "queueMax": "Max",
      "queueProfile": "Profile",
      "queueHealth": "Health data",
      "queueMetabolic": "Metabolic data",
      "queueRequest": "Change",
      "stuckTitle": "Writes that didn't go through"
    },
    "stuckWrites": {
      "banner_one": "{{count}} save didn't go through",
      "banner_other": "{{count}} saves didn't go through",
      "retry": "Retry now",
      "retrying": "Trying again…",
      "details": "Details"
    },
    "progress": {
      "title": "Progress",
      "windowAll": "Recent sessions",
      "window30d": "Last 30 days",
      "window7d": "Last 7 days",
      "lastSession": "Last session",
      "frequencyTitle": "Weekly frequency",
      "frequencyHelp": "Sessions per week, last {{weeks}} weeks (current week on the right).",
      "recordsTitle": "Records",
      "recordsHelp": "Best per-rep records per exercise. Latest update first.",
      "recordsEmpty": "No records yet. Log a few weighted sets to populate.",
      "recordsAllTime": "All-time",
      "recordsThisYear": "{{year}}",
      "recordsSearch": "Filter by exercise",
      "recordsNoMatch": "No exercise matches the filter.",
      "tagVolumeTitle": "Volume by tag",
      "tagVolumeHelp": "Training volume per muscle/tag over the recent window.",
      "chartE1rm": "Estimated 1RM",
      "chartVolume": "Volume",
      "chartScope": "Based on the most recent {{n}} sessions.",
      "chartLoadFailed": "Could not load chart data.",
      "chartEmpty": "No weighted sets in the recent window.",
      "viewByExercise": "By exercise",
      "viewByTag": "By tag",
      "noTags": "No exercises with tags in the recent window.",
      "totalVolume": "Total: {{weight}}",
      "chartMax": "MAX (kg)",
      "chartEstimatedBadge": "with e1RM overlay",
      "prFound": "PR found: {{weight}}",
      "prUpdate": "Update MAX to {{weight}}",
      "prUpdating": "Updating…",
      "painSeverity": {
        "red": "red",
        "yellow": "yellow",
        "green": "green"
      },
      "balance": {
        "title": "Movement balance",
        "help": "Sets and volume per movement pattern over the selected {{days}}-day window, sorted by sets. The small \"X/7d\" number is the last-7-day count, useful to spot a single recent push (or a deliberate drop) that the longer window hides."
      },
      "empty": "No recent activity to compare",
      "pain": {
        "title": "Pain × volume",
        "help": "For every muscle currently flagged in your painMap, shows recent training load. Red dot = pain reported red (avoid heavy load), yellow = caution, green = monitor. The two volume numbers are last-7-day vs the selected {{days}}-day load on that muscle — sustained heavy load on a red muscle is the highest-risk signal in the dashboard.",
        "noPain": "No muscles flagged in painMap",
        "sevRed": "Avoid",
        "sevYellow": "Caution",
        "sevGreen": "Monitor"
      },
      "trends": {
        "a11yUp": "progressing",
        "a11yFlat": "plateau",
        "a11yDown": "regressing",
        "title": "E1RM trends",
        "help": "For each movement pattern (squat, hinge, push, pull, …) shows the exercise where your top e1RM is highest. Chart = e1RM points over the selected {{days}}-day window (tap a point for its value). Arrow = trend over that window: ↗ progressing, → plateau, ↘ regressing. \"Few data\" badge appears when there are fewer than 3 points to fit a line.",
        "fewData": "Few data points in {{days}} d",
        "notMeasurable": "Not measurable yet: no {{name}} set went near its limit. A set taken close to failure (an AMRAP) would show your strength here.",
        "machineNotMeasurable": "{{value}}, not measurable yet",
        "machineMore": "{{machine}} · +{{count}}",
        "machineA11y_one": "{{exercise}}, {{machine}}. Show the other machine.",
        "machineA11y_other": "{{exercise}}, {{machine}}. Show the other {{count}} machines.",
        "machineSessions_one": "{{count}} session",
        "machineSessions_other": "{{count}} sessions"
      },
      "repsAtLoad": {
        "a11yUp": "climbing",
        "a11yFlat": "flat",
        "a11yDown": "falling",
        "title": "Reps at load",
        "help": "For the exercises where you keep training the same load, this tracks the reps at that fixed weight over the selected {{days}}-day window — the strength gain the e1RM chart can't see on high-rep and machine work. Chart = reps at the load over time (tap a point). Arrow = trend: ↗ climbing, → flat, ↘ falling. Only effort-tagged sets count, so more reps can't just mean an easier day.",
        "repsValue": "{{reps}} × {{load}}",
        "fewData": "Few data points in {{days}} d",
        "notMeasurable": "Not measurable yet: your {{name}} sets at {{load}} aren't tagged with effort, so more reps might just mean an easier day. A set taken near failure — or an effort tag — would show your strength here."
      },
      "period": {
        "all": "all"
      },
      "loadFailed": "Couldn’t load",
      "density": {
        "title": "Density",
        "help": "Volume divided by session duration, kg/min. Reads as \"how dense was that session\" — going up means you work the same load in less time (better conditioning) or more load in the same time (better strength). A sudden drop without changing the program often means fatigue: the rests stretched even if you didn't plan them.",
        "empty": "Need 3+ timed sessions to chart density"
      },
      "frequency": {
        "title": "Stalest exercises",
        "help": "Top 8 exercises sorted by days-since-last-logged, stalest first. The X/{{days}}d suffix is the sets-in-the-selected-window count. Numbers in red = 14+ days untouched: either you intentionally cut it, or the program drifted. Useful to spot accessory work that quietly disappeared.",
        "today": "today",
        "daysAgo": "{{n}} d ago"
      },
      "fatigueDrift": {
        "title": "Fatigue drift (RIR)",
        "help": "Rolling weekly average of RPE and reps-in-reserve on sets where both are logged. Rising RPE with falling RIR on similar loads = accumulated fatigue showing before the bar slows down. A backoff week or deload usually clears it.",
        "noData": "Log RPE and RIR on a few sets to chart fatigue drift",
        "rising": "Rising fatigue",
        "stable": "Stable",
        "legend": "RPE (left) · RIR (right) — tap a week for values"
      },
      "intensityHeatmap": {
        "title": "Intensity heatmap",
        "help": "Per-exercise grid of completed sets sorted by rep range and intensity (% of 1RM). Strength range (85%+) at the bottom right, hypertrophy in the middle, endurance top left. Pick an exercise above to see where its sets cluster.",
        "exerciseLabel": "Exercise",
        "choosePrompt": "Choose an exercise",
        "noEligible": "Record a 1RM on at least one exercise to compute intensity.",
        "noMax": "No 1RM recorded for this exercise yet.",
        "totalSets": "{{n}} sets · 1RM {{max}}",
        "clear": "None"
      },
      "a11y": {
        "severityAlarm": "Alarm",
        "severityWarn": "Warning",
        "severityInfo": "Info",
        "stale": "Stale"
      }
    },
    "profile": {
      "title": "Profile",
      "navMaxes": "MAXes",
      "navMaxesSub": "Set, edit and review your MAXes per exercise.",
      "navCatalogSub": "Browse exercises, records and history.",
      "navRestTimer": "Timers",
      "navRestTimerSub": "Rest + hold defaults, sound, per-exercise",
      "labelEmail": "EMAIL",
      "labelApp": "APP VERSION",
      "labelBackend": "BACKEND VERSION",
      "labelPrivacy": "PRIVACY",
      "privacyHelp": "Export everything as JSON or delete the account permanently.",
      "exportButton": "Export my data",
      "deleteButton": "Delete my account",
      "deleteAlertTitle": "Delete account",
      "deleteAlertBody": "Your account, sessions, plans, programs and maxes will be permanently deleted. Deletions are not recoverable.",
      "deleteAlertCancel": "Cancel",
      "deleteAlertConfirm": "Delete",
      "signOut": "Sign out",
      "exportShareTitle": "JackedLogs export {{date}}",
      "labelLanguage": "Language",
      "languageHelp": "Pick the language used across the app. Saved on this device.",
      "languageCancel": "Close"
    },
    "timeline": {
      "setNumber": "Set {{n}}",
      "fail": "Fail",
      "failTip": "Fail logs the set as attempted but not completed. It still counts as done (the rest timer runs), shows ✕ in the timeline, and is left out of your e1RM.",
      "failTipA11y": "What does Fail mean?",
      "e1rmValue": "e1RM {{value}}",
      "e1rmPctOfBest": "{{pct}}% of best",
      "e1rmNewBest": "best",
      "e1rmLegend": "e1RM",
      "setVolume": "Σ {{value}} {{unit}}",
      "myorepTag": "Myo-rep",
      "dropsetTag": "Drop",
      "myorepA11y": "Myo-rep set",
      "dropsetA11y": "Drop set",
      "setVolumeA11y": "Set volume {{value}} {{unit}}",
      "setSummaryBothSidesA11y": "{{reps}} reps at {{weight}} {{unit}} per side, both sides counted",
      "e1rmLegendA11y": "What is e1RM?",
      "e1rmTip": "e1RM is your estimated 1-rep max for the set (Epley, reps ≤ 12). “% of best” compares it to your best e1RM in recent history — lower means room to push; ↑ best means a new estimated record.",
      "durationLabel": "Duration",
      "hourShort": "h",
      "minShort": "min",
      "secShort": "sec",
      "started": "Workout started",
      "addSet": "Add set",
      "removeSet": "Remove set",
      "prevSet": "Previous set",
      "nextSet": "Next set",
      "allLogged": "All sets logged — tap + to add another.",
      "rosterLabel": "Exercises",
      "rosterHint": "tap to switch",
      "focusEmptyHasRoster": "Select an exercise above to start, or add a new one.",
      "focusAllLogged": "All sets logged. Add an exercise above, or save below.",
      "cueNextSet": "→ Set {{n}}/{{total}}",
      "cueNextExercise": "→ {{name}}",
      "rosterExpandA11y": "Expand exercise list",
      "rosterCollapseA11y": "Collapse exercise list",
      "rosterState": {
        "done": "done",
        "inProgress": "in progress",
        "notDone": "not started"
      },
      "rosterOccurrenceA11y": "{{label}} ({{index}} of {{count}})",
      "exerciseNote": "Exercise note",
      "notePlaceholder": "Add a note to the timeline…",
      "noteSend": "Send note",
      "noteExpandA11y": "Note — tap to read in full",
      "noteDeleteA11y": "Delete note",
      "dropsetActive": "Dropset — edit the rounds below.",
      "editingLogged": "Editing logged set {{n}} — changes save with the workout.",
      "addSetLocked": "Editing a past session: you can't add sets. Fix the values or remove a set instead.",
      "createGroupLocked": "Editing a past session: you can't create a superset.",
      "splitGroupLocked": "Editing a past session: you can't dissolve a superset.",
      "setTypeLocked": "Editing a past session: you can't change the set type (dropset/myorep).",
      "addStepLocked": "Editing a past session: you can't add a dropset step.",
      "setState": {
        "pending": "Set {{n}} of {{total}}, not done",
        "done": "Set {{n}} of {{total}}, done",
        "pr": "Set {{n}} of {{total}}, personal record",
        "failed": "Set {{n}} of {{total}}, failed"
      },
      "holdLabel": "Hold"
    },
    "summary": {
      "prBadge": "personal record"
    },
    "logger": {
      "title": "New workout",
      "cancel": "Cancel",
      "swapKindTitle": "Change exercise type?",
      "swapKindBody": "This exercise is logged a different way, so the sets you already logged here will be cleared.",
      "swapKindConfirm": "Change & clear",
      "failConfirmTitle": "Clean reps",
      "failConfirmBody_one": "Saving {{count}} clean rep. The failed one does not count.",
      "failConfirmBody_other": "Saving {{count}} clean reps. The failed one does not count.",
      "failConfirmHint": "Adjust if you did more or fewer than that.",
      "failConfirmStepDown": "One fewer clean rep",
      "failConfirmStepUp": "One more clean rep",
      "failConfirmSave": "Save",
      "amrapConfirmTitle": "Did you go to failure?",
      "amrapConfirmBody": "Answer yes only if the next rep would not have come up.",
      "amrapNeedsReps": "Type the reps you did to log this set.",
      "amrapBadgeWithFloor": "AMRAP ≥ {{reps}}",
      "amrapPrescribedFloorA11y": "AMRAP: at least {{reps}} reps, then as many as possible",
      "amrapConfirmAtFloor": "You logged {{reps}}, and the plan asked for at least {{floor}}.",
      "amrapFloorPlaceholder": "≥ {{reps}}",
      "amrapConfirmYes": "Yes, to failure",
      "amrapConfirmNo": "No, I had more in me",
      "failBadge": "Failed",
      "failBadgeA11y": "failed set",
      "save": "Save",
      "remove": "Remove",
      "replace": "Replace",
      "addExercise": "Add exercise",
      "addSet": "Add set",
      "addRound": "Add round",
      "pickerTitle": "Pick exercise",
      "pickerSearch": "Search exercises",
      "pickerEmpty": "No exercises match.",
      "pickerClearFilters": "Clear filters",
      "pickerFilters": "Filters",
      "pickerFiltersN": "Filters ({{n}})",
      "empty": "No exercises yet. Add one to start logging.",
      "setReps": "REPS",
      "amrapPrescribedA11y": "AMRAP: at least the target reps, then as many as possible",
      "setWeight": "KG",
      "setWeightLb": "LB",
      "setWeightBothSidesA11y": "Weight of one side, both sides counted ({{unit}})",
      "setTypeWorking": "Working",
      "setTypeDropset": "Dropset",
      "setTypeMyorep": "Myo-rep",
      "setCommentLabel": "Set comment",
      "unitLabel": "Unit",
      "discardTitle": "Discard workout?",
      "discardBody": "You will lose the entries you have logged so far.",
      "discardCancel": "Keep logging",
      "discardConfirm": "Discard",
      "errNoEntries": "Add at least one exercise.",
      "errNoSets": "Each exercise needs at least one set with reps and weight.",
      "errInvalid": "The workout can't be saved as is.",
      "errSaveFailed": "Save failed. Tap retry on the queue banner once you are online.",
      "setNumberHeader": "SET",
      "removeSetA11y": "Remove this set",
      "serverErrorTitle": "SERVER REJECTED THE SAVE",
      "serverErrorHint": "Adjust the workout and try again. If the message is unclear, share it with your coach.",
      "setExtra": "EXTRA",
      "bwPromptTitle": "Register your bodyweight",
      "bwPromptBody": "Bodyweight exercises need your weight to compute load and volume. Set it in Settings → Body.",
      "bwPromptCta": "Set it",
      "setWeightTip": "Weight lifted per set. Switch kg/lb with the unit chip on each row.",
      "setExtraTip": "Bodyweight assistance or added load. Type a minus (−) for band/machine assist (the field turns amber); a belt/plate add is positive.",
      "setWeightMixedTip": "Mixed group: barbell/stack load on weighted rows, ± extra on bodyweight rows (minus = assist).",
      "editTitle": "Edit workout",
      "repeatTitle": "Repeat workout",
      "minimize": "Minimize workout",
      "closeWorkout": "Close workout",
      "saveWorkout": "Save workout",
      "bilateral": "Bilateral",
      "unilateral": "Unilateral",
      "plates": "Plates",
      "numInvalid": "Invalid number",
      "numRange": "{{label}} {{min}}–{{max}}",
      "setRpeHint": "1–10 effort",
      "setNoteLabel": "Note",
      "setNotePlaceholder": "Cue, form check, sensation…",
      "elapsedA11y": "Elapsed time",
      "totalsSets_one": "{{count}} set",
      "totalsSets_other": "{{count}} sets",
      "totalsReps_one": "{{count}} rep",
      "totalsReps_other": "{{count}} reps",
      "totalsTitle": "Workout totals",
      "totalsVolume": "Volume",
      "totalsSetsShort": "Sets",
      "totalsRepsShort": "Reps",
      "totalsByMuscle": "Work by muscle",
      "restRest": "Rest",
      "startRestManual": "Start rest timer",
      "restSkip": "Skip",
      "restWord": "Rest",
      "restAddStep": "+{{n}} seconds",
      "restSubtractStep": "−{{n}} seconds",
      "restRemainingA11y": "{{time}} of rest remaining",
      "restLockedA11y": "Editing locked while resting. Tap skip to edit.",
      "restEditA11y": "Set default rest for this exercise",
      "restEditTitle": "Default rest",
      "restEditBody": "Save this rest as default for {{name}}",
      "restEditSave": "Save",
      "restEditSaving": "Saving…",
      "restEditError": "Could not save the default rest. Try again.",
      "restEditCancel": "Cancel",
      "restEditSaveAsGlobal": "Use as global default",
      "restStepMinus": "Decrease by {{step}} seconds",
      "restStepPlus": "Increase by {{step}} seconds",
      "restPause": "Pause",
      "restResume": "Resume",
      "restExpiredTitle": "Rest over",
      "holdExpiredTitle": "Time's up",
      "restExpiredBody": "Time to lift again.",
      "holdExpiredBody": "Tap the effort band to log the set.",
      "boutExpiredTitle": "Bout done",
      "boutExpiredBody": "Set logged for you.",
      "boutAutoLoggedA11y": "Bout done, {{time}} logged.",
      "workoutFgsTitle": "Workout in progress",
      "workoutFgsBodyNamed": "{{name}} · tap to resume",
      "workoutFgsBody": "Tap to resume your session",
      "descriptionToggle": "Show / hide description",
      "notesToggle": "Coach notes for this workout",
      "notesProgramLabel": "Program",
      "notesWorkoutLabel": "This workout",
      "note": "Note",
      "rpeChip": "RPE",
      "historyChip": "History",
      "more": "More actions",
      "addGroup": "Group with another exercise",
      "cardioDuration": "Duration",
      "cardioDurationPlaceholder": "Seconds",
      "cardioDistance": "Distance",
      "cardioWeight": "Weight",
      "cardioHr": "Avg HR",
      "cardioCalories": "Calories",
      "cardioOptionalsShow": "Show other fields",
      "cardioOptionalsHide": "Hide other fields",
      "dateEditor": "Date & duration",
      "dateLabel": "Date",
      "startTimeLabel": "Start",
      "endTimeLabel": "End",
      "durationLabel": "Duration",
      "historyToggle": "History",
      "historyCount_one": "{{count}} session",
      "historyCount_other": "{{count}} sessions",
      "historyBest": "Best",
      "historyCopy": "Copy",
      "historyBodyweight": "{{reps}} reps BW",
      "historyEstimateHeader": "Estimate from a similar exercise",
      "historyEstimatedFrom": "From {{name}}",
      "historyNoEstimate": "No history yet, and no similar exercise to estimate from.",
      "copyDialogTitle": "Copy session",
      "copyDialogBody": "Replace pending sets or add to existing?",
      "copyOverwrite": "Replace",
      "copyAppend": "Add",
      "resumeTitle": "Resume workout?",
      "resumeBody": "You started a workout on {{date}} that wasn't saved. Resume it or discard?",
      "resumeContinue": "Resume",
      "resumeDiscard": "Discard",
      "conflictTitle": "Workout in progress",
      "conflictBody": "You're already logging a workout. Keep it running, or show it to save or discard.",
      "nameLabel": "Workout name",
      "namePlaceholder": "Name: e.g. Push…",
      "editNameA11y": "Edit workout name",
      "setStateA11y": "set {{index}} {{state}}",
      "rpePlaceholder": "RPE",
      "unitA11y": "unit {{unit}}",
      "stepperPositive": "positive",
      "stepperNegative": "negative",
      "historyCount": "{{n}} sessions",
      "rirPlaceholder": "RIR",
      "effortMeterEasy": "Easy",
      "effortMeterHard": "Hard",
      "effortWord": "Effort",
      "holdSlotDone": "DONE",
      "holdSlotHeld": "HELD",
      "holdSlotDoneA11y": "{{time}} done",
      "holdSlotFailedA11y": "{{time}}, failed",
      "holdSlotHeldA11y": "{{time}} held",
      "effortMeterFail": "Fail",
      "effortMeterTargetWord": "target",
      "effortQuestionRir": "Reps in reserve?",
      "effortQuestionRpe": "How hard was it?",
      "effortQuestionHint": "Opens the effort scale — how it works and how to switch it",
      "effortMeterHintLog": "Also logs the set as completed",
      "effortMeterHintRunning": "Stops the timer and logs the set",
      "effortMeterHintEdit": "Updates the effort of this logged set",
      "effortMeterFailHintLog": "Logs the set as failed",
      "effortMeterFailHintEdit": "Switches this set between done and failed",
      "effortMeterTapCta": "Tap to log the set",
      "effortMeterStopCta": "Tap to stop and log",
      "effortNudgeOptOut": "Turn off reminder",
      "effortNudgeOptOutHint": "Asks you to confirm first. You can turn it back on in Settings.",
      "effortNudgeOptOutConfirmTitle": "Turn off this reminder?",
      "effortNudgeOptOutConfirmBody": "You can turn it back on anytime in Settings.",
      "effortNudgeOptOutConfirmButton": "Turn off",
      "effortMeterAmrapDone": "Done",
      "effortMeterAmrapHint": "Logs the set at failure — no reps left",
      "amrapChip": "As many reps as possible",
      "burnPlus": "Burn+",
      "burnPlusChip": "Burn+ intensity technique (dropset / myo-rep)",
      "effortLegendA11y": "Effort scale help",
      "rirLegendTitle": "RIR: reps in reserve",
      "rirLegendBody": "0 = no reps left\n1 = 1 rep left\n2 = 2 reps left\n3 = comfortable margin\n4+ = easy / warm-up",
      "rpeLegendTitle": "RPE: rate of perceived exertion",
      "rpeLegendBody": "10 = no reps left\n9 = 1 rep left\n8 = 2 reps left\n7 = comfortable margin\n6 or less = easy / warm-up",
      "timerStartCountdown": "Start countdown",
      "timerStartCountup": "Start stopwatch",
      "timerSettings": "Timer defaults for this exercise",
      "holdHeaderHours": "h",
      "holdHeaderMinutes": "min",
      "holdHeaderSeconds": "s",
      "holdHours": "Hours",
      "holdMinutes": "Minutes",
      "holdSeconds": "Seconds",
      "holdSubTen": "-10s",
      "holdAddTen": "+10s",
      "holdCancel": "Cancel",
      "holdClockElapsedA11y": "{{time}} elapsed",
      "holdClockOvertimeA11y": "{{time}} past the target",
      "holdClockPausedA11y": "{{label}}, paused",
      "holdClockRemainingA11y": "{{time}} remaining",
      "holdFlip": "Switch direction",
      "holdExtraWeight": "Extra",
      "lateralityTipUni": "UNI · log one side; volume counts both (×2).",
      "lateralityTipBi": "BI · bilateral load; volume counts once (×1).",
      "tabExercises": "Exercises",
      "tabSuperset": "Superset",
      "pickerAddN": "Add {{n}}",
      "pickerAlreadyInWorkout": "Already in this workout",
      "pickerAlreadyInBlock": "Already in this block",
      "pickerPin": "Pin favourite",
      "pickerUnpin": "Unpin favourite",
      "noteReadA11y": "Exercise note — tap to read in full",
      "prescriptionReadA11y": "Prescribed set cue — tap to read in full",
      "helpToggle": "Help — tap a chip to learn what it does",
      "tipAmrap": "As many reps as possible — take this set to technical failure.",
      "tipBurnPlus": "Intensity techniques — reveal Dropset or Myo-rep to push a set past failure.",
      "helpBanner": "Help mode — tap a chip to learn what it does; tap ⓘ to exit.",
      "helpModeHint": "Help mode is on — this explains instead of changing the setting.",
      "targetsMore": "+{{count}} more",
      "targetEyebrow": "Target"
    },
    "coachBanner": {
      "a11y": "{{count}} coach invitations waiting for you",
      "one": "1 coach invitation waiting",
      "many": "{{count}} coach invitations waiting",
      "action": "Open"
    },
    "coachEdges": {
      "empty": "No coach edges yet. A coach can invite you from the web app."
    },
    "toxicDraft": {
      "banner": "Recovered a corrupted workout.",
      "viewJson": "View JSON",
      "sendSupport": "Send to support",
      "dismiss": "Discard",
      "close": "Close",
      "jsonTitle": "Quarantined workout",
      "supportPrefix": "Corrupted draft auto-detected by the boot-attempt counter. Quarantined JSON below.",
      "sentTitle": "Send to support",
      "sentBody": "Recovery payload sent.",
      "sendError": "Send failed. The workout is still in quarantine."
    },
    "recovery": {
      "banner": "Recovered workout",
      "summary": "{{date}} · {{exercises}} exercises · {{done}}/{{total}} sets done",
      "saveAsNew": "Save as new",
      "discard": "Discard",
      "title": "Recovered workout",
      "openBody": "This workout was interrupted and recovered. Check the sets and tap Save to log it as a new workout.",
      "open": "Open",
      "cancel": "Cancel",
      "liveBusy": "You have a workout in progress. Save or discard it before recovering this one.",
      "discardTitle": "Discard recovered workout?",
      "discardBody": "This recovered workout will be permanently deleted.",
      "discardConfirm": "Discard",
      "error": "Couldn't recover the workout. Try again.",
      "merge": "Merge…",
      "mergeTitle": "Merge workout",
      "mergePrompt": "Pick a same-day workout to merge into:",
      "noSameDay": "No same-day workout to merge into. Use \"Save as new\".",
      "nothingToMerge": "No completed sets to merge. Use \"Save as new\"."
    },
    "group": {
      "title": "Group this exercise",
      "close": "Close",
      "standalone": "Standalone",
      "supersetSection": "SUPERSETS",
      "circuitSection": "CIRCUITS",
      "supersetN": "Superset {{n}}",
      "circuitN": "Circuit {{n}}",
      "newSuperset": "+ New superset",
      "newCircuit": "+ New circuit",
      "groupCta": "+ Superset"
    },
    "webview": {
      "close": "Close",
      "openExternal": "Open in browser",
      "errorTitle": "The page didn't load",
      "errorBody": "Tap below to try the system browser instead.",
      "fallbackErrorTitle": "Couldn't open the browser",
      "fallbackErrorBody": "Try again from a different network."
    },
    "plates": {
      "title": "Plate calculator",
      "close": "Close",
      "apply": "Apply",
      "targetLabel": "Target",
      "barLabel": "Bar",
      "perSide": "Per side: {{kg}} kg",
      "barOnly": "Empty bar — no plates needed.",
      "pairs_one": "{{count}} pair",
      "pairs_other": "{{count}} pairs",
      "plates_one": "{{count}} plate",
      "plates_other": "{{count}} plates",
      "loadedEnd": "Loaded end: {{kg}} kg",
      "landmineHint": "Landmine: only the free end is loaded. The other end is anchored to the floor pivot.",
      "remainder": "Off by {{kg}} kg — inventory can't match exactly.",
      "belowBar": "Target is below the bar weight.",
      "invalid": "Enter a valid weight.",
      "inventoryShow": "Edit plate inventory",
      "inventoryHide": "Hide plate inventory",
      "inventoryTitle": "Pairs available",
      "pairsIncrement": "Add a pair",
      "pairsDecrement": "Remove a pair",
      "signLabel": "EXTRA SIGN",
      "signAdd": "+ Weighted",
      "signAssist": "− Assist"
    },
    "restTimerScreen": {
      "title": "Timers",
      "back": "Back"
    },
    "licenses": {
      "title": "Open source licenses",
      "back": "Back",
      "headlineIntro": "JackedLogs leans on a small set of libraries that materially shape the app. Tap a row to open the project — and consider sponsoring the ones you use the most.",
      "coreSection": "Core libraries ({{count}})",
      "viewAllTitle": "View all packages",
      "viewAllSub": "Full attribution for the {{count}} packages bundled in the APK, grouped by project.",
      "allTitle": "All packages ({{count}})",
      "searchAll": "Search name, group, license or author",
      "groupOther": "Other packages",
      "empty": "No package matches that search.",
      "footer": "Generated {{date}}",
      "openErrorTitle": "Cannot open link"
    },
    "share": {
      "newPR": "NEW PR",
      "topLifts": "TOP LIFTS",
      "durationMinute": "min",
      "durationHour": "h",
      "durationMinuteShort": "m",
      "footerSets": "sets",
      "footerDensitySuffix": "/min",
      "fallbackLabel": "Total Volume",
      "timeLabel": "Total Time",
      "tutLabel": "TUT",
      "impulseUnit": "kg·s",
      "impulseLabel": "Impulse",
      "e1rmSuffix": "E1RM"
    },
    "postSession": {
      "blockCalories": "Calories",
      "blockEffort": "Effort",
      "effortHr": "{{avg}} avg · {{peak}} peak bpm",
      "effortHrMax": "{{pct}}% HRmax",
      "shareTitle": "JackedLogs session",
      "shareErrorTitle": "Share failed",
      "headlineLabelPR": "NEW E1RM",
      "headlineLabelDelta": "BIG JUMP +{{delta}}",
      "headlineLabelSolid": "SOLID SESSION",
      "headlineSolidValue": "{{volume}} in {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} sets",
      "blockTopLifts": "Top Lifts",
      "fromSet": "from {{weight}} × {{reps}}",
      "blockVolume": "Volume",
      "blockDuration": "Duration",
      "blockDensity": "Density",
      "barsTitle": "Work by muscle",
      "bodyTitle": "Muscles worked",
      "sharing": "Preparing…",
      "shareCta": "Share session card",
      "done": "Done",
      "summaryTitle": "Workout saved"
    },
    "common": {
      "back": "Back",
      "save": "Save",
      "cancel": "Cancel",
      "close": "Close"
    },
    "account": {
      "title": "Account",
      "navSub": "Name, password, export, delete, sign out",
      "nameLabel": "NAME",
      "namePlaceholder": "Your name",
      "saved": "Saved",
      "passwordLabel": "CHANGE PASSWORD",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "confirmPassword": "Confirm new password",
      "passwordChanged": "Password changed.",
      "passwordSubmit": "Update password",
      "deleteNeedsConnection": "Deleting your account needs a connection. Reconnect and try again — this request is never saved for later."
    },
    "prefs": {
      "title": "Units & display",
      "navSub": "Units, language, hints",
      "unitsLabel": "Units",
      "unitsHelp": "Default weight unit for new sets. You can still override per row in the logger.",
      "weekStartLabel": "Week starts on",
      "weekStartHelp": "Which day your training week resets. Weekly muscle targets count from this day.",
      "unitsKg": "Kilograms (kg)",
      "unitsLb": "Pounds (lb)",
      "glucoseUnitsLabel": "Glucose units",
      "glucoseUnitsHelp": "How glucose is shown and entered. Stored the same either way.",
      "glucoseMmol": "mmol/L",
      "glucoseMgdl": "mg/dL",
      "themePaletteLabel": "Theme palette",
      "themePaletteHelp": "Pick the colour palette used across the app.",
      "themeModeLabel": "Appearance",
      "themeModeHelp": "Follow the system setting, or force light or dark.",
      "themeMode": {
        "system": "System",
        "light": "Light",
        "dark": "Dark"
      }
    },
    "home": {
      "targetsTopPatterns": "Top patterns",
      "targetsSummary": "{{on}} of {{total}} on target",
      "targetsHint": "Pin a program with weekly targets to score these against a goal.",
      "targetsZoneOnTarget": "on target",
      "targetsZoneOver": "over",
      "targetsZoneUnder": "building",
      "targetsNoCoverage": "no coverage",
      "targetsPrescribed": "plan {{n}}",
      "targetsEmptyTitle": "No goals yet",
      "targetsEmptySub": "Set how much you want to train each muscle per week. Your plan works toward it; the Home meter shows where you are.",
      "targetsEmptyCta": "Set your goals",
      "weekEyebrow": "This week",
      "weeklyTitle": "Last 7 days",
      "weeklySessions": "Workouts",
      "weeklyVolume": "Volume",
      "weeklyA11y": "{{sessions}} workouts, {{volume}} volume",
      "viewProgress": "View progress",
      "badgesTitle": "Badges",
      "newsTitle": "News",
      "newsEmpty": "App news will show up here.",
      "prPrev": "Previous record",
      "prNext": "Next record",
      "prPosition": "Record {{n}} of {{total}}",
      "eyebrow": "TODAY",
      "blankTitle": "Ready to train?",
      "blankLoading": "Loading your plan…",
      "blankBody": "No active program right now. Start a blank workout, or use ＋ to plan one.",
      "newWorkout": "New workout",
      "programMeta": "{{program}} · Week {{week}}",
      "morePreview": " +{{count}} more",
      "startToday": "▶ Start session",
      "blankInstead": "Start a blank workout instead",
      "recentPrValue": "{{weight}} × {{reps}}",
      "recentPrValueBodyweight": "{{reps}} reps BW",
      "prToday": "Today",
      "prDaysAgo": "{{n}} d ago",
      "weightTitle": "Body weight",
      "weightSaved": "Saved ✓",
      "weightCurrent": "Latest: {{value}} {{unit}}",
      "weightNone": "Log your weight to track trends.",
      "weightSave": "Save",
      "repeatWorkout": "Repeat a past workout",
      "form": {
        "title": "Readiness",
        "ready": "Ready",
        "caution": "Caution",
        "rest": "Rest",
        "reasonNoData": "Log a session to start tracking your readiness.",
        "reasonWellRecovered": "Well rested since your last session — good to push.",
        "reasonBalanced": "Your training load looks balanced.",
        "reasonFreshStart": "Getting back into it — ease in and build a base.",
        "reasonShortRest": "Back-to-back sessions — keep an eye on recovery.",
        "reasonHighFrequency": "A high-volume week — consider a lighter day.",
        "reasonLoadSpike": "Your load jumped sharply vs your recent average.",
        "reasonLongGap": "It's been a while — start light to ramp back up."
      },
      "glucoseSave": "Save",
      "weightSaveA11y": "Save body weight",
      "glucoseSaveA11y": "Save glucose reading"
    },
    "superset": {
      "startingWith": "Starting superset with",
      "joinExisting": "Join existing",
      "pairInWorkout": "Pair with (in this workout)",
      "templates": "Saved supersets",
      "templateInsertHint": "Insert this superset; long-press to delete",
      "templateDeleteBody": "Remove this saved superset?",
      "createCta": "Create superset ({{n}})",
      "cueCycle": "{{group}}, exercise {{pos}} of {{total}}. Tap to go to {{next}}.",
      "cueStatic": "{{group}}, exercise {{pos}} of {{total}}",
      "menuOpen": "Superset options",
      "menuSaveTemplate": "Save as template",
      "menuAddExercise": "Add exercise",
      "menuMoveUp": "Move up",
      "menuMoveDown": "Move down",
      "menuRemoveMember": "Remove this exercise",
      "menuSplit": "Dissolve superset",
      "namePlaceholder": "Superset name (optional)"
    }
  },
  "tabs": {
    "workout": "Workout",
    "plan": "Plan",
    "progress": "Progress",
    "profile": "Profile",
    "catalog": "Catalog",
    "admin": "Admin",
    "workoutEyebrow": "Today's session",
    "planEyebrow": "Programming",
    "progressEyebrow": "Charts and reports",
    "profileEyebrow": "Account & maxes",
    "catalogEyebrow": "Exercise catalog",
    "adminEyebrow": "Admin console",
    "progressEmpty": "Log a session first — charts arrive once there's data."
  },
  "shell": {
    "navAria": "Primary navigation"
  },
  "theme": {
    "aria": "Theme",
    "light": "Light",
    "dark": "Dark",
    "auto": "Auto"
  },
  "import": {
    "title": "Import workouts from CSV",
    "help": "Upload an export from another tracker. You confirm you own the data and you accept that what gets imported into JackedLogs is your responsibility. Workouts that are already imported are detected by id and skipped.",
    "sourceLabel": "Source platform",
    "source": {
      "strengthlog": "StrengthLog"
    },
    "sourceHint": {
      "strengthlog": "From StrengthLog: open Settings, choose Export, pick Logs full export. Save the CSV anywhere and pick it below. The original filename does not matter."
    },
    "languageDisclaimer": "Exercise names are matched in English. Names in other languages will be created as draft exercises that you can rename manually in the catalog.",
    "consent": "I exported this file from my own account and I am the owner of the data.",
    "fileLabel": "CSV file",
    "parsing": "Parsing the file…",
    "cancel": "Cancel",
    "confirm": "Start import",
    "again": "Import another file",
    "done": "Import finished",
    "seedMaxesPrompt": "Want to seed your MAXes from the imported workouts? The Profile tab has a one-click suggestion based on every set you just imported.",
    "seedMaxesGo": "Seed MAXes from history",
    "summary": {
      "rows": "{{count}} rows",
      "sessions": "{{count}} sessions",
      "exercises": "{{count}} exercises",
      "dateRange": "{{from}} to {{to}}",
      "autoMatched": "{{count}} matched against the catalog",
      "draftsToCreate": "{{count}} new draft exercises will be created",
      "unparseable": "{{count}} names could not be turned into a slug and will be skipped",
      "unparseableShow": "Show the names"
    },
    "draftsCallout": "Drafts are tagged auto_imported. They are usable for logging right away. An athlete or coach can review and promote them later, add muscles and equipment, or merge duplicates.",
    "draftsProgress": "Creating draft exercises: {{done}} / {{total}}",
    "mappingsTitle": "Exercise mapping",
    "mappingsStats": "{{matched}} auto-matched · {{pending}} to resolve · {{resolved}} resolved · {{skipped}} skipped",
    "allResolved": "All exercises are resolved. You can start the import.",
    "confidenceHint": "Closest match: {{top}} ({{pct}}%)",
    "toggle": {
      "showResolved": "Show resolved ({{count}})",
      "hideResolved": "Hide resolved",
      "showMatched": "Show auto-matched ({{count}})",
      "hideMatched": "Hide auto-matched"
    },
    "action": {
      "create": "Create as new exercise",
      "pickExisting": "Use an existing one",
      "skip": "Skip"
    },
    "create": {
      "name": "Exercise name",
      "bodyweight": "Bodyweight exercise (no external load)",
      "submit": "Create",
      "submitting": "Creating…"
    },
    "pick": {
      "label": "Catalog exercise",
      "placeholder": "Pick one…",
      "rememberAlias": "Remember \"{{csvName}}\" as an alias for the next imports",
      "submit": "Confirm",
      "submitting": "Saving…"
    },
    "skip": {
      "help": "Sets on this exercise will not be imported. You can change your mind below.",
      "submit": "Confirm skip"
    },
    "resolved": {
      "auto": "→ {{name}} (auto-matched)",
      "linked": "→ {{name}} (linked)",
      "linkedAlias": "→ {{name}} (linked, alias saved)",
      "created": "→ {{name}} (created)",
      "skipped": "skipped",
      "undo": "Undo"
    },
    "mapping": {
      "suggestions": "Suggestions",
      "allCatalog": "All catalog"
    },
    "progress": {
      "label": "{{done}} / {{total}} ({{pct}}%)",
      "tally": "Created {{created}} · Already imported {{duplicates}} · Failed {{failed}}"
    },
    "report": {
      "created": "Workouts created: {{count}}",
      "duplicates": "Already imported: {{count}}",
      "draftsCreated": "Draft exercises created: {{count}}",
      "invalid": "Invalid payload: {{count}}",
      "unknownExercise": "Unknown exercise: {{count}}",
      "failed": "Failed: {{count}}",
      "detailsToggle": "Show failures",
      "moreFailures": "and {{more}} more"
    },
    "errors": {
      "catalogNotReady": "The exercise catalog is still loading. Wait a moment and pick the file again.",
      "emptyFile": "No rows found in the file.",
      "missingColumns": "Missing required columns: {{columns}}.",
      "parseFailed": "Could not parse the file.",
      "nothingToImport": "Nothing to import after creating drafts. Check the file.",
      "draftsFailed": "Could not create draft exercises: {{message}}"
    }
  },
  "settings": {
    "restDefaults": {
      "title": "Rest timer defaults",
      "globalLabel": "Global default",
      "globalUnset": "Not set — using {{n}}s",
      "customLabel": "Exercises with a custom default",
      "customEmpty": "No per-exercise overrides. Open the rest banner inside the Logger and tap ⚙ to set one.",
      "customRemoveA11y": "Remove custom rest for {{name}}",
      "clearGlobal": "Reset"
    },
    "hints": {
      "title": "Hints",
      "label": "Show hint tooltips",
      "help": "Tap a column header to see what it means. Turn off to hide the hint bubbles."
    },
    "effortNudge": {
      "label": "Effort reminder",
      "help": "A rare, gentle pulse on the effort bar while a set waits to be logged."
    },
    "inWorkoutMeter": {
      "label": "In-workout target meter",
      "help": "A strip at the top of the exercise card with the weekly target for the muscles you are training."
    },
    "audio": {
      "title": "Audio",
      "soundLabel": "Timer sound",
      "soundHelp": "Plays when the rest timer expires.",
      "vibrationLabel": "Vibration",
      "vibrationHelp": "Vibrate when the rest timer expires.",
      "previewButton": "Play",
      "pickerTitle": "Choose a sound",
      "pickerCancel": "Cancel",
      "category": {
        "serious": "Standard",
        "fun": "Fun"
      },
      "soundOptions": {
        "none": "None",
        "chime_crisp": "Chime",
        "ding_dong": "Ding-dong",
        "meditation_bell": "Meditation bell",
        "tada_fanfare": "Ta-da",
        "cartoon_boing": "Boing",
        "ah_yeah": "Yeah!"
      }
    },
    "timerDefaults": {
      "range": "Enter {{min}}–{{max}}s",
      "globalTitle": "Global defaults",
      "restGlobal": "Rest timer",
      "holdGlobal": "Hold timer",
      "customLabel": "Per-exercise overrides",
      "customEmpty": "No per-exercise overrides yet. Tap + Add.",
      "unset": "Not set — {{n}}s",
      "add": "+ Add",
      "editRestA11y": "Edit rest override for {{name}}",
      "editHoldA11y": "Edit hold override for {{name}}",
      "editA11y": "Edit timer defaults for {{name}}",
      "isDefault": "default",
      "equalsDefaultHint": "A value left equal to the global default is not saved as an override.",
      "remove": "Remove"
    },
    "backend": {
      "section": "Backend",
      "title": "Backend",
      "navSub": "Choose where this build writes",
      "pickLabel": "Write my data to",
      "pickHelp": "Dev build only. Each backend keeps its own session, queues and workout draft — switching never touches the other one.",
      "stageProduction": "PRODUCTION",
      "stageLab": "LABORATORY",
      "liveLabel": "WRITING TO",
      "liveChecking": "Checking…",
      "liveUnknown": "Unknown — the backend did not answer",
      "liveNotProduction": "This is not where your real training lives.",
      "confirmTitle": "Switch backend?",
      "confirmBody": "The app reloads against {{stage}}. You may have to sign in there, and cached lists are dropped.",
      "confirmCta": "Switch",
      "blockedByQueue": "Not switched: some writes have not gone out yet. Get back online and let the queues drain first."
    },
    "animations": {
      "cellularLabel": "Download animations without Wi-Fi",
      "cellularHelp": "Off by default. The animations are there either way: this only lets the app fetch them ahead of time on mobile data, roughly 20 to 30 MB for a programme."
    }
  },
  "web": {
    "crash": {
      "body": "The app hit an unexpected error. Your saved data is safe — reload to continue.",
      "reload": "Reload"
    },
    "postSession": {
      "headlineLabelPR": "NEW E1RM",
      "headlineLabelDelta": "BIG JUMP +{{delta}}",
      "headlineLabelSolid": "SOLID SESSION",
      "headlineSolidValue": "{{volume}} in {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} sets",
      "blockE1rm": "E1RM",
      "fromSet": "from {{weight}} × {{reps}}",
      "blockVolume": "Volume",
      "blockDuration": "Duration",
      "blockDensity": "Density",
      "barsTitle": "Work by muscle",
      "bodyTitle": "Muscles worked",
      "sharing": "Preparing…",
      "shareCta": "Share session card"
    }
  },
  "muscle": {
    "quadriceps": "Quads",
    "hamstrings": "Hamstrings",
    "glutes": "Glutes",
    "adductors": "Adductors",
    "abductors": "Abductors",
    "calves": "Calves",
    "core": "Core",
    "obliques": "Obliques",
    "erectors": "Lower back",
    "pectoralis": "Chest",
    "anterior-delts": "Front delts",
    "lateral-delts": "Side delts",
    "triceps": "Triceps",
    "lats": "Lats",
    "rhomboids": "Upper back",
    "rear-delts": "Rear delts",
    "traps": "Traps",
    "biceps": "Biceps",
    "forearms": "Forearms"
  },
  "experience": {
    "menuLabel": "Active profile",
    "athlete": "Athlete",
    "coach": "Coach",
    "admin": "Admin"
  },
  "composer": {
    "targetAxisExercise": "Exercise",
    "targetKeyExercise": "Exercise",
    "targetRefAvg": "~{{n}}/wk avg",
    "targetRefLast": "last wk {{n}}",
    "targetRefNone": "No data in the last 4 weeks",
    "targetRefProgram": "program prescribes ~{{n}}/wk",
    "targetUseAvg": "Use average",
    "targetUseProgram": "Use program value",
    "projectionTitle": "How targets land",
    "projectionWeek": "Week {{n}}",
    "projectionContext": "Sets / load the program prescribes in week {{n}}.",
    "projectionTarget": "Target",
    "projectionWeekTotal": "Week",
    "projectionRamp": "Cycle",
    "projectionWeekShort": "W{{n}}",
    "projectionEmpty": "Not scheduled",
    "targetsTitle": "Weekly targets",
    "targetsEmptyTitle": "No weekly targets",
    "targetsEmptySub": "Add one to light up the level meter.",
    "targetAdd": "Add target",
    "targetRemove": "Remove target {{name}}",
    "targetCollapse": "Collapse",
    "targetAxis": "Axis",
    "targetAxisMuscle": "Muscle",
    "targetMetric": "Metric",
    "targetMetricHardSets": "Hard sets",
    "targetMetricTonnage": "Tonnage",
    "targetMetricReps": "Reps",
    "prescriptionEyebrow": "Prescription",
    "prescriptionSub": "What this block prescribes each week, measured against your goals.",
    "targetKeyMuscle": "Muscle",
    "targetValue": "Weekly goal",
    "targetUnitHardSets": "hard sets",
    "targetUnitTonnage": "kg",
    "targetUnitReps": "reps",
    "targetBand": "±{{pct}}%",
    "targetNotScored": "not in meter yet",
    "targetNotScoredNote": "This target type isn't scored by the level meter yet.",
    "targetBandLabel": "Tolerance",
    "targetBandAsym": "−{{lo}}% / +{{hi}}%",
    "targetBandBelow": "Percent below goal",
    "targetBandAbove": "Percent above goal",
    "targetBandRange": "Below 0–99%, above 0% or more.",
    "compose": "Compose",
    "preview": "Preview",
    "addExercises": "Add exercises",
    "editingBlockDay": "Editing D{{d}} — Update applies to this day (tick more days to apply there too)",
    "editingRampDay": "Weekly ramp on D{{d}} — Update applies to the selected weeks, this day only",
    "segments": "Segments",
    "rampSwitchHint": "Update or Cancel before switching segment",
    "setupHint": "Set the starting shape — you can add or remove days and change the weeks later in the editor.",
    "repsHint": "Reps “5+” = AMRAP: at least 5, then as many as possible.",
    "repsHintA11y": "How reps are written",
    "addingWeek": "New week W{{n}} — Update adds it to this exercise",
    "cloneWeek": "Clone week…",
    "cloneWeekFrom": "From",
    "cloneWeekApply": "Clone",
    "cloneWeekConflict": "{{name}} already has content in W{{week}} (D{{day}})",
    "cloneWeekEmpty": "Nothing to clone — pick a filled source week and at least one target",
    "cloneDayEmpty": "Nothing to clone on this day",
    "editingWeekDay": "Editing W{{n}} on D{{d}} only — Update breaks it out of its segment",
    "perWeek": "Per week",
    "dupExercise": "{{name}} is already on D{{day}} in the selected weeks",
    "cloneDay": "Clone D{{n}} to…",
    "cloneDayTarget": "To",
    "days": "Days",
    "weeks": "Weeks",
    "setNote": "Set note",
    "removeExercise": "Remove exercise",
    "replaceExercise": "Replace exercise",
    "clone": "Clone",
    "remove": "Remove",
    "removeConfirm": "Confirm? ({{n}} cells)",
    "verbatim": "Advanced slot (multi-variant) — preserved as-is, not editable here",
    "metaWeeks": "{{n}} weeks",
    "metaDays": "{{n}} training days",
    "gridToggle": "Intensity grid",
    "addDay": "Add day",
    "removeDay": "Remove day D{{n}}",
    "removeDayConfirm": "Confirm — remove day D{{n}}?",
    "dayEmpty": "No exercises on this day yet. Add one to build it.",
    "checkEmptyCell": "W{{w}}·D{{d}} has no exercises",
    "checkPctNoMax": "{{name}} uses %MAX without a saved MAX",
    "exerciseNote": "Exercise note",
    "exerciseNotePlaceholder": "Note for this exercise (shown while logging)",
    "panelHint": "Tap an exercise to edit, clone or remove",
    "warnLine_one": "{{count}} warning",
    "warnLine_other": "{{count}} warnings",
    "adjacencyWarnLine_one": "{{count}} muscle-recovery warning",
    "adjacencyWarnLine_other": "{{count}} muscle-recovery warnings",
    "adjacencyWarnItem": "{{muscle}} trained on adjacent days ({{count}}×)",
    "publishChecklist": "Open warnings (publishing anyway is fine)",
    "publishClean": "No open warnings.",
    "weekShort": "Week",
    "placed": "on",
    "notPlaced": "off",
    "placementHint": "Hold a cell to place or remove it here.",
    "addWeek": "Add week",
    "removeWeek": "Remove week",
    "removeWeekConfirm": "Confirm — drop this week and its sets"
  },
  "gym": {
    "setPlace": "Where?",
    "whichPlace": "Where are you training?",
    "newPlace": "Add place",
    "fallback": "Default",
    "chipA11y": "Training place",
    "footnote": "Sorts what you see first. Never shared with a coach.",
    "namePlaceTitle": "Name this place",
    "namePlaceHint": "Place name",
    "namePlaceSave": "Use this place",
    "pinPlace": "Set {{place}} as your default place",
    "unpinPlace": "Remove {{place}} as your default place",
    "pinHint": "Remembers this as the place you usually train at.",
    "unpinHint": "Forgets your default place.",
    "pinErrorTitle": "Not saved",
    "pinErrorBody": "Your default place is unchanged."
  }
}
